import { jsx as o, jsxs as f, Fragment as X } from "react/jsx-runtime";
import Yt from "@mui/material/Button";
import qt from "@mui/icons-material/ThumbUp";
import { useTranslate as et, useNotify as G, useRedirect as xe, useResourceContext as te, useRecordContext as z, useUpdate as tt, useListContext as se, useUnselectAll as Qt, useUpdateMany as Xt, Button as ot, useDataProvider as Z, Link as rt, useCreatePath as Zt, ReferenceField as Ct, FunctionField as eo, ReferenceOneField as to, TextField as ve, BooleanField as Uo, ArrayField as Wo, DateField as Oo, SelectField as _o, NumberField as jo, useInput as oo, FormDataConsumer as ro, ReferenceArrayInput as no, SelectArrayInput as so, useGetList as fe, TextInput as io, DateInput as ao, SelectInput as nt, ReferenceInput as lo, NumberInput as co, AutocompleteInput as uo, ReferenceManyField as Bo, Datagrid as Go, Pagination as Vo, DELETE_MANY as kt, DELETE as St, CREATE as It, UPDATE_MANY as Rt, UPDATE as At, GET_ONE as Tt, GET_LIST as Pt, GET_MANY_REFERENCE as Dt, GET_MANY as Lt, Create as Ho, SimpleForm as mo, useDefaultTitle as st, useCreateContext as Ko, SaveButton as Jo, DeleteButton as Yo, Edit as qo, useEditContext as Qo, TopToolbar as Xo, DeleteWithConfirmButton as Zo, CloneButton as er, ListButton as tr, ShowButton as or, RecordContextProvider as rr, DataTable as po, BulkDeleteButton as nr, SavedQueriesList as sr, FilterList as ir, FilterListItem as ar, SearchInput as lr, useSidebarState as cr, List as dr, downloadCSV as ur, usePermissions as mr, useResourceDefinition as pr, Show as gr, SimpleShowLayout as hr } from "react-admin";
import go, { memo as fr, Fragment as Ne, useState as N, useEffect as V } from "react";
import { Box as x, Typography as I, Card as _, CardContent as j, Grid as ce, Chip as de, Link as br, Avatar as qe, ListItem as it, ListItemButton as at, ListItemAvatar as yr, ListItemText as lt, CardHeader as ue, Stack as Q, Paper as ho, FormControlLabel as Qe, Checkbox as Fe, Divider as me, alpha as Re, Skeleton as Be, Button as be, Menu as xr, MenuItem as vr, IconButton as Ee, Collapse as fo, List as ct, CardActions as wr, CircularProgress as $e, Alert as bo, AlertTitle as yo, Stepper as Cr, Step as kr, StepLabel as Sr, StepContent as Ir, Dialog as Rr, DialogTitle as Ar, DialogContent as Tr, DialogActions as Pr, InputLabel as Nt, TextField as Ge, colors as Ve, useTheme as Dr, useMediaQuery as Lr } from "@mui/material";
import Ae from "prop-types";
import { makeStyles as Nr } from "@mui/styles";
import { PaymentOutlined as Fr, AccountCircle as Er, Add as zr, ExpandLess as $r, ExpandMore as xo, Delete as Mr, OpenInNew as Ur, InboxOutlined as Wr, BugReport as Ft, GpsFixed as Or, CreditCard as _r, Security as jr, Info as Br, Phone as Gr, Update as Vr, Search as Hr, Dataset as Kr } from "@mui/icons-material";
import vo from "@mui/icons-material/ThumbDown";
import { useNavigate as Me } from "react-router-dom";
import { useNavigate as Jr } from "react-router";
import Yr from "@mui/material/Toolbar";
import qr from "@mui/icons-material/InboxOutlined";
import Qr from "jsonexport/dist";
import { styled as Xr, useTheme as Zr, alpha as H } from "@mui/material/styles";
import { jwtDecode as Le } from "jwt-decode";
import Et from "object-diff";
const en = ({ redirectUrl: e, successMessage: t = "Record was rejected successfully", errorMessage: r = "Record was not rejected", label: n = "Accept" }) => {
  const s = et(), a = G(), c = xe(), i = te(), u = z(), [d, { isPending: p }] = tt(
    i,
    { id: u?.id, data: { status: "accepted" }, previousData: u },
    {
      mutationMode: "undoable",
      onSuccess: () => {
        a(t, {
          type: "info",
          undoable: !0
        }), e && c(e);
      },
      onError: () => {
        a(r, {
          type: "error"
        });
      }
    }
  );
  return u && u.status === "pending" ? /* @__PURE__ */ o(Yt, { variant: "outlined", color: "primary", size: "small", onClick: () => d(), sx: { borderColor: (h) => h.palette.success.main }, startIcon: /* @__PURE__ */ o(qt, { sx: { color: (h) => h.palette.success.main } }), disabled: p, children: s(n) }) : /* @__PURE__ */ o("span", {});
}, tn = [], on = ({ successMessage: e = "Record was accepted successfully", errorMessage: t = "Record was not accepted", label: r = "Accept" }) => {
  const { selectedIds: n = tn } = se(), s = te(), a = G(), c = Qt(s), [i, { isPending: u }] = Xt(
    s,
    { ids: n, data: { status: "accepted" } },
    {
      mutationMode: "undoable",
      onSuccess: () => {
        a(e, {
          type: "info",
          undoable: !0
        }), c();
      },
      onError: () => {
        a(t, {
          type: "error"
        });
      }
    }
  );
  return /* @__PURE__ */ o(ot, { label: r, onClick: () => i(), disabled: u, children: /* @__PURE__ */ o(qt, {}) });
}, rn = [], nn = ({ successMessage: e = "Record was rejected successfully", errorMessage: t = "Record was not rejected", label: r = "Reject" }) => {
  const { selectedIds: n = rn } = se(), s = te(), a = G(), c = Qt(s), [i, { isPending: u }] = Xt(
    s,
    { ids: n, data: { status: "rejected" } },
    {
      mutationMode: "undoable",
      onSuccess: () => {
        a(e, {
          type: "info",
          undoable: !0
        }), c();
      },
      onError: () => {
        a(t, {
          type: "error"
        });
      }
    }
  );
  return /* @__PURE__ */ o(ot, { label: r, onClick: () => i(), disabled: u, children: /* @__PURE__ */ o(vo, {}) });
}, sn = ({ redirectUrl: e, successMessage: t = "Record was rejected successfully", errorMessage: r = "Record was not rejected", label: n = "Reject" }) => {
  const s = et(), a = G(), c = xe(), i = te(), u = z(), [d, { isPending: p }] = tt(
    i,
    { id: u?.id, data: { status: "rejected" }, previousData: u },
    {
      mutationMode: "undoable",
      onSuccess: () => {
        a(t, {
          type: "info",
          undoable: !0
        }), e && c(e);
      },
      onError: () => {
        a(r, {
          type: "error"
        });
      }
    }
  );
  return u && u.status === "pending" ? /* @__PURE__ */ o(Yt, { variant: "outlined", color: "primary", size: "small", onClick: () => d(), sx: { borderColor: (h) => h.palette.error.main }, startIcon: /* @__PURE__ */ o(vo, { sx: { color: (h) => h.palette.error.main } }), disabled: p, children: s(n) }) : /* @__PURE__ */ o("span", {});
};
function wo(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var s = e.length;
    for (t = 0; t < s; t++) e[t] && (r = wo(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function an() {
  for (var e, t, r = 0, n = "", s = arguments.length; r < s; r++) (e = arguments[r]) && (t = wo(e)) && (n && (n += " "), n += t);
  return n;
}
const ln = (e, t) => {
  const r = new Array(e.length + t.length);
  for (let n = 0; n < e.length; n++)
    r[n] = e[n];
  for (let n = 0; n < t.length; n++)
    r[e.length + n] = t[n];
  return r;
}, cn = (e, t) => ({
  classGroupId: e,
  validator: t
}), Co = (e = /* @__PURE__ */ new Map(), t = null, r) => ({
  nextPart: e,
  validators: t,
  classGroupId: r
}), ze = "-", zt = [], dn = "arbitrary..", un = (e) => {
  const t = pn(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = e;
  return {
    getClassGroupId: (c) => {
      if (c.startsWith("[") && c.endsWith("]"))
        return mn(c);
      const i = c.split(ze), u = i[0] === "" && i.length > 1 ? 1 : 0;
      return ko(i, u, t);
    },
    getConflictingClassGroupIds: (c, i) => {
      if (i) {
        const u = n[c], d = r[c];
        return u ? d ? ln(d, u) : u : d || zt;
      }
      return r[c] || zt;
    }
  };
}, ko = (e, t, r) => {
  if (e.length - t === 0)
    return r.classGroupId;
  const s = e[t], a = r.nextPart.get(s);
  if (a) {
    const d = ko(e, t + 1, a);
    if (d) return d;
  }
  const c = r.validators;
  if (c === null)
    return;
  const i = t === 0 ? e.join(ze) : e.slice(t).join(ze), u = c.length;
  for (let d = 0; d < u; d++) {
    const p = c[d];
    if (p.validator(i))
      return p.classGroupId;
  }
}, mn = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const t = e.slice(1, -1), r = t.indexOf(":"), n = t.slice(0, r);
  return n ? dn + n : void 0;
})(), pn = (e) => {
  const {
    theme: t,
    classGroups: r
  } = e;
  return gn(r, t);
}, gn = (e, t) => {
  const r = Co();
  for (const n in e) {
    const s = e[n];
    dt(s, r, n, t);
  }
  return r;
}, dt = (e, t, r, n) => {
  const s = e.length;
  for (let a = 0; a < s; a++) {
    const c = e[a];
    hn(c, t, r, n);
  }
}, hn = (e, t, r, n) => {
  if (typeof e == "string") {
    fn(e, t, r);
    return;
  }
  if (typeof e == "function") {
    bn(e, t, r, n);
    return;
  }
  yn(e, t, r, n);
}, fn = (e, t, r) => {
  const n = e === "" ? t : So(t, e);
  n.classGroupId = r;
}, bn = (e, t, r, n) => {
  if (xn(e)) {
    dt(e(n), t, r, n);
    return;
  }
  t.validators === null && (t.validators = []), t.validators.push(cn(r, e));
}, yn = (e, t, r, n) => {
  const s = Object.entries(e), a = s.length;
  for (let c = 0; c < a; c++) {
    const [i, u] = s[c];
    dt(u, So(t, i), r, n);
  }
}, So = (e, t) => {
  let r = e;
  const n = t.split(ze), s = n.length;
  for (let a = 0; a < s; a++) {
    const c = n[a];
    let i = r.nextPart.get(c);
    i || (i = Co(), r.nextPart.set(c, i)), r = i;
  }
  return r;
}, xn = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, vn = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ Object.create(null), n = /* @__PURE__ */ Object.create(null);
  const s = (a, c) => {
    r[a] = c, t++, t > e && (t = 0, n = r, r = /* @__PURE__ */ Object.create(null));
  };
  return {
    get(a) {
      let c = r[a];
      if (c !== void 0)
        return c;
      if ((c = n[a]) !== void 0)
        return s(a, c), c;
    },
    set(a, c) {
      a in r ? r[a] = c : s(a, c);
    }
  };
}, Xe = "!", $t = ":", wn = [], Mt = (e, t, r, n, s) => ({
  modifiers: e,
  hasImportantModifier: t,
  baseClassName: r,
  maybePostfixModifierPosition: n,
  isExternal: s
}), Cn = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: r
  } = e;
  let n = (s) => {
    const a = [];
    let c = 0, i = 0, u = 0, d;
    const p = s.length;
    for (let b = 0; b < p; b++) {
      const y = s[b];
      if (c === 0 && i === 0) {
        if (y === $t) {
          a.push(s.slice(u, b)), u = b + 1;
          continue;
        }
        if (y === "/") {
          d = b;
          continue;
        }
      }
      y === "[" ? c++ : y === "]" ? c-- : y === "(" ? i++ : y === ")" && i--;
    }
    const h = a.length === 0 ? s : s.slice(u);
    let l = h, m = !1;
    h.endsWith(Xe) ? (l = h.slice(0, -1), m = !0) : (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      h.startsWith(Xe) && (l = h.slice(1), m = !0)
    );
    const g = d && d > u ? d - u : void 0;
    return Mt(a, m, l, g);
  };
  if (t) {
    const s = t + $t, a = n;
    n = (c) => c.startsWith(s) ? a(c.slice(s.length)) : Mt(wn, !1, c, void 0, !0);
  }
  if (r) {
    const s = n;
    n = (a) => r({
      className: a,
      parseClassName: s
    });
  }
  return n;
}, kn = (e) => {
  const t = /* @__PURE__ */ new Map();
  return e.orderSensitiveModifiers.forEach((r, n) => {
    t.set(r, 1e6 + n);
  }), (r) => {
    const n = [];
    let s = [];
    for (let a = 0; a < r.length; a++) {
      const c = r[a], i = c[0] === "[", u = t.has(c);
      i || u ? (s.length > 0 && (s.sort(), n.push(...s), s = []), n.push(c)) : s.push(c);
    }
    return s.length > 0 && (s.sort(), n.push(...s)), n;
  };
}, Sn = (e) => ({
  cache: vn(e.cacheSize),
  parseClassName: Cn(e),
  sortModifiers: kn(e),
  postfixLookupClassGroupIds: In(e),
  ...un(e)
}), In = (e) => {
  const t = /* @__PURE__ */ Object.create(null), r = e.postfixLookupClassGroups;
  if (r)
    for (let n = 0; n < r.length; n++)
      t[r[n]] = !0;
  return t;
}, Rn = /\s+/, An = (e, t) => {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: s,
    sortModifiers: a,
    postfixLookupClassGroupIds: c
  } = t, i = [], u = e.trim().split(Rn);
  let d = "";
  for (let p = u.length - 1; p >= 0; p -= 1) {
    const h = u[p], {
      isExternal: l,
      modifiers: m,
      hasImportantModifier: g,
      baseClassName: b,
      maybePostfixModifierPosition: y
    } = r(h);
    if (l) {
      d = h + (d.length > 0 ? " " + d : d);
      continue;
    }
    let C = !!y, R;
    if (C) {
      const $ = b.substring(0, y);
      R = n($);
      const k = R && c[R] ? n(b) : void 0;
      k && k !== R && (R = k, C = !1);
    } else
      R = n(b);
    if (!R) {
      if (!C) {
        d = h + (d.length > 0 ? " " + d : d);
        continue;
      }
      if (R = n(b), !R) {
        d = h + (d.length > 0 ? " " + d : d);
        continue;
      }
      C = !1;
    }
    const P = m.length === 0 ? "" : m.length === 1 ? m[0] : a(m).join(":"), A = g ? P + Xe : P, L = A + R;
    if (i.indexOf(L) > -1)
      continue;
    i.push(L);
    const O = s(R, C);
    for (let $ = 0; $ < O.length; ++$) {
      const k = O[$];
      i.push(A + k);
    }
    d = h + (d.length > 0 ? " " + d : d);
  }
  return d;
}, Tn = (...e) => {
  let t = 0, r, n, s = "";
  for (; t < e.length; )
    (r = e[t++]) && (n = Io(r)) && (s && (s += " "), s += n);
  return s;
}, Io = (e) => {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let n = 0; n < e.length; n++)
    e[n] && (t = Io(e[n])) && (r && (r += " "), r += t);
  return r;
}, Pn = (e, ...t) => {
  let r, n, s, a;
  const c = (u) => {
    const d = t.reduce((p, h) => h(p), e());
    return r = Sn(d), n = r.cache.get, s = r.cache.set, a = i, i(u);
  }, i = (u) => {
    const d = n(u);
    if (d)
      return d;
    const p = An(u, r);
    return s(u, p), p;
  };
  return a = c, (...u) => a(Tn(...u));
}, Dn = [], F = (e) => {
  const t = (r) => r[e] || Dn;
  return t.isThemeGetter = !0, t.themeKey = e, t;
}, Ro = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, Ao = /^\((?:(\w[\w-]*):)?(.+)\)$/i, Ln = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, Nn = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Fn = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, En = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix|color|light-dark)\(.+\)$/, zn = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, $n = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, ee = (e) => Ln.test(e), T = (e) => !!e && !Number.isNaN(Number(e)), K = (e) => !!e && Number.isInteger(Number(e)), He = (e) => e.endsWith("%") && T(e.slice(0, -1)), Y = (e) => Nn.test(e), To = () => !0, Mn = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Fn.test(e) && !En.test(e)
), ut = () => !1, Un = (e) => zn.test(e), Wn = (e) => $n.test(e), On = (e) => !v(e) && !w(e), _n = (e) => e.startsWith("@container") && (e[10] === "/" && e[11] !== void 0 || e[11] === "s" && e[16] !== void 0 && e.startsWith("-size/", 10) || e[11] === "n" && e[18] !== void 0 && e.startsWith("-normal/", 10)), jn = (e) => oe(e, Lo, ut), v = (e) => Ro.test(e), ne = (e) => oe(e, No, Mn), Ut = (e) => oe(e, qn, T), Bn = (e) => oe(e, Eo, To), Gn = (e) => oe(e, Fo, ut), Wt = (e) => oe(e, Po, ut), Vn = (e) => oe(e, Do, Wn), Te = (e) => oe(e, zo, Un), w = (e) => Ao.test(e), pe = (e) => ie(e, No), Hn = (e) => ie(e, Fo), Ot = (e) => ie(e, Po), Kn = (e) => ie(e, Lo), Jn = (e) => ie(e, Do), Pe = (e) => ie(e, zo, !0), Yn = (e) => ie(e, Eo, !0), oe = (e, t, r) => {
  const n = Ro.exec(e);
  return n ? n[1] ? t(n[1]) : r(n[2]) : !1;
}, ie = (e, t, r = !1) => {
  const n = Ao.exec(e);
  return n ? n[1] ? t(n[1]) : r : !1;
}, Po = (e) => e === "position" || e === "percentage", Do = (e) => e === "image" || e === "url", Lo = (e) => e === "length" || e === "size" || e === "bg-size", No = (e) => e === "length", qn = (e) => e === "number", Fo = (e) => e === "family-name", Eo = (e) => e === "number" || e === "weight", zo = (e) => e === "shadow", Qn = () => {
  const e = F("color"), t = F("font"), r = F("text"), n = F("font-weight"), s = F("tracking"), a = F("leading"), c = F("breakpoint"), i = F("container"), u = F("spacing"), d = F("radius"), p = F("shadow"), h = F("inset-shadow"), l = F("text-shadow"), m = F("drop-shadow"), g = F("blur"), b = F("perspective"), y = F("aspect"), C = F("ease"), R = F("animate"), P = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], A = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], L = () => [...A(), w, v], O = () => ["auto", "hidden", "clip", "visible", "scroll"], $ = () => ["auto", "contain", "none"], k = () => [w, v, u], W = () => [ee, "full", "auto", ...k()], gt = () => [K, "none", "subgrid", w, v], ht = () => ["auto", {
    span: ["full", K, w, v]
  }, K, w, v], we = () => [K, "auto", w, v], ft = () => ["auto", "min", "max", "fr", w, v], Ue = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], ae = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], B = () => ["auto", ...k()], re = () => [ee, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...k()], We = () => [i, ee, "screen", "full", "dvw", "lvw", "svw", "min", "max", "fit", ...k()], Oe = () => [ee, "screen", "full", "lh", "dvh", "lvh", "svh", "min", "max", "fit", ...k()], S = () => [e, w, v], bt = () => [...A(), Ot, Wt, {
    position: [w, v]
  }], yt = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], xt = () => ["auto", "cover", "contain", Kn, jn, {
    size: [w, v]
  }], _e = () => [He, pe, ne], M = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    d,
    w,
    v
  ], U = () => ["", T, pe, ne], Ce = () => ["solid", "dashed", "dotted", "double"], vt = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], E = () => [T, He, Ot, Wt], wt = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    g,
    w,
    v
  ], ke = () => ["none", T, w, v], Se = () => ["none", T, w, v], je = () => [T, w, v], Ie = () => [ee, "full", ...k()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [Y],
      breakpoint: [Y],
      color: [To],
      container: [Y],
      "drop-shadow": [Y],
      ease: ["in", "out", "in-out"],
      font: [On],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [Y],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [Y],
      shadow: [Y],
      spacing: ["px", T],
      text: [Y],
      "text-shadow": [Y],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", ee, v, w, y]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Container Type
       * @see https://tailwindcss.com/docs/responsive-design#container-queries
       */
      "container-type": [{
        "@container": ["", "normal", "size", w, v]
      }],
      /**
       * Container Name
       * @see https://tailwindcss.com/docs/responsive-design#named-containers
       */
      "container-named": [_n],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [T, "auto", v, w, i]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": P()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": P()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: L()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: O()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": O()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": O()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: $()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": $()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": $()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: W()
      }],
      /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": W()
      }],
      /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": W()
      }],
      /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */
      start: [{
        "inset-s": W(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        start: W()
      }],
      /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */
      end: [{
        "inset-e": W(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        end: W()
      }],
      /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-bs": [{
        "inset-bs": W()
      }],
      /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-be": [{
        "inset-be": W()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: W()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: W()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: W()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: W()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [K, "auto", w, v]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [ee, "full", "auto", i, ...k()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [T, ee, "auto", "initial", "none", v]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", T, w, v]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", T, w, v]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [K, "first", "last", "none", w, v]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": gt()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ht()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": we()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": we()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": gt()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ht()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": we()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": we()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ft()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ft()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: k()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": k()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": k()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...Ue(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...ae(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...ae()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...Ue()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...ae(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...ae(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": Ue()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...ae(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...ae()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: k()
      }],
      /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: k()
      }],
      /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: k()
      }],
      /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: k()
      }],
      /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: k()
      }],
      /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */
      pbs: [{
        pbs: k()
      }],
      /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */
      pbe: [{
        pbe: k()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: k()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: k()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: k()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: k()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: B()
      }],
      /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: B()
      }],
      /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: B()
      }],
      /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: B()
      }],
      /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: B()
      }],
      /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */
      mbs: [{
        mbs: B()
      }],
      /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */
      mbe: [{
        mbe: B()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: B()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: B()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: B()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: B()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": k()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": k()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: re()
      }],
      /**
       * Inline Size
       * @see https://tailwindcss.com/docs/inline-size
       */
      "inline-size": [{
        inline: ["auto", ...We()]
      }],
      /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-inline-size
       */
      "min-inline-size": [{
        "min-inline": ["auto", ...We()]
      }],
      /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-inline-size
       */
      "max-inline-size": [{
        "max-inline": ["none", ...We()]
      }],
      /**
       * Block Size
       * @see https://tailwindcss.com/docs/block-size
       */
      "block-size": [{
        block: ["auto", ...Oe()]
      }],
      /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-block-size
       */
      "min-block-size": [{
        "min-block": ["auto", ...Oe()]
      }],
      /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-block-size
       */
      "max-block-size": [{
        "max-block": ["none", ...Oe()]
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [i, "screen", ...re()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          i,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...re()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          i,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [c]
          },
          ...re()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...re()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...re()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", "none", ...re()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", r, pe, ne]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [n, Yn, Bn]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", He, v]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Hn, Gn, t]
      }],
      /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */
      "font-features": [{
        "font-features": [v]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [s, w, v]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [T, "none", w, Ut]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          a,
          ...k()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", w, v]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", w, v]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: S()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: S()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Ce(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [T, "from-font", "auto", w, ne]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: S()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [T, "auto", w, v]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: k()
      }],
      /**
       * Tab Size
       * @see https://tailwindcss.com/docs/tab-size
       */
      "tab-size": [{
        tab: [K, w, v]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", w, v]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", w, v]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: bt()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: yt()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: xt()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, K, w, v],
          radial: ["", w, v],
          conic: ["", K, w, v]
        }, Jn, Vn]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: S()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: _e()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: _e()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: _e()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: S()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: S()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: S()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: M()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": M()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": M()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": M()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": M()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": M()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": M()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": M()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": M()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": M()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": M()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": M()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": M()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": M()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": M()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: U()
      }],
      /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": U()
      }],
      /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": U()
      }],
      /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": U()
      }],
      /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": U()
      }],
      /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-bs": [{
        "border-bs": U()
      }],
      /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-be": [{
        "border-be": U()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": U()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": U()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": U()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": U()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": U()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": U()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Ce(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...Ce(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: S()
      }],
      /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": S()
      }],
      /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": S()
      }],
      /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": S()
      }],
      /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": S()
      }],
      /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-bs": [{
        "border-bs": S()
      }],
      /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-be": [{
        "border-be": S()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": S()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": S()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": S()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": S()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: S()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...Ce(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [T, w, v]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", T, pe, ne]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: S()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          // Deprecated since Tailwind CSS v4.0.0
          "inner",
          "none",
          p,
          Pe,
          Te
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: S()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", h, Pe, Te]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": S()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: U()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: S()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [T, ne]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": S()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": U()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": S()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", l, Pe, Te]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": S()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [T, w, v]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...vt(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": vt()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [T]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": E()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": E()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": S()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": S()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": E()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": E()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": S()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": S()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": E()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": E()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": S()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": S()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": E()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": E()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": S()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": S()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": E()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": E()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": S()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": S()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": E()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": E()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": S()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": S()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": E()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": E()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": S()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": S()
      }],
      "mask-image-radial": [{
        "mask-radial": [w, v]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": E()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": E()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": S()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": S()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": A()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [T]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": E()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": E()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": S()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": S()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: bt()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: yt()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: xt()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", w, v]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          w,
          v
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: wt()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [T, w, v]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [T, w, v]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          m,
          Pe,
          Te
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": S()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", T, w, v]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [T, w, v]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", T, w, v]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [T, w, v]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", T, w, v]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          w,
          v
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": wt()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [T, w, v]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [T, w, v]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", T, w, v]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [T, w, v]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", T, w, v]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [T, w, v]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [T, w, v]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", T, w, v]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": k()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": k()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": k()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", w, v]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [T, "initial", w, v]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", C, w, v]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [T, w, v]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", R, w, v]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [b, w, v]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": L()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: ke()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": ke()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": ke()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": ke()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: Se()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": Se()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": Se()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": Se()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: je()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": je()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": je()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [w, v, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: L()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: Ie()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": Ie()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": Ie()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": Ie()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      /**
       * Zoom
       * @see https://tailwindcss.com/docs/zoom
       */
      zoom: [{
        zoom: [K, w, v]
      }],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: S()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: S()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", w, v]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scrollbar Thumb Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */
      "scrollbar-thumb-color": [{
        "scrollbar-thumb": S()
      }],
      /**
       * Scrollbar Track Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */
      "scrollbar-track-color": [{
        "scrollbar-track": S()
      }],
      /**
       * Scrollbar Gutter
       * @see https://tailwindcss.com/docs/scrollbar-gutter
       */
      "scrollbar-gutter": [{
        "scrollbar-gutter": ["auto", "stable", "both"]
      }],
      /**
       * Scrollbar Width
       * @see https://tailwindcss.com/docs/scrollbar-width
       */
      "scrollbar-w": [{
        scrollbar: ["auto", "thin", "none"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": k()
      }],
      /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": k()
      }],
      /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": k()
      }],
      /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": k()
      }],
      /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": k()
      }],
      /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbs": [{
        "scroll-mbs": k()
      }],
      /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbe": [{
        "scroll-mbe": k()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": k()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": k()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": k()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": k()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": k()
      }],
      /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": k()
      }],
      /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": k()
      }],
      /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": k()
      }],
      /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": k()
      }],
      /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbs": [{
        "scroll-pbs": k()
      }],
      /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbe": [{
        "scroll-pbe": k()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": k()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": k()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": k()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": k()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", w, v]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...S()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [T, pe, ne, Ut]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...S()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      "container-named": ["container-type"],
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "inset-bs", "inset-be", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["start", "end", "right", "left"],
      "inset-y": ["inset-bs", "inset-be", "top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pbs", "pbe", "pt", "pr", "pb", "pl"],
      px: ["ps", "pe", "pr", "pl"],
      py: ["pbs", "pbe", "pt", "pb"],
      m: ["mx", "my", "ms", "me", "mbs", "mbe", "mt", "mr", "mb", "ml"],
      mx: ["ms", "me", "mr", "ml"],
      my: ["mbs", "mbe", "mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-bs", "border-w-be", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-s", "border-w-e", "border-w-r", "border-w-l"],
      "border-w-y": ["border-w-bs", "border-w-be", "border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-bs", "border-color-be", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-s", "border-color-e", "border-color-r", "border-color-l"],
      "border-color-y": ["border-color-bs", "border-color-be", "border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-ms", "scroll-me", "scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-ps", "scroll-pe", "scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    postfixLookupClassGroups: ["container-type"],
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, Xn = /* @__PURE__ */ Pn(Qn), Ke = {
  base: "text-white rounded-md transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-indigo-500 disabled:opacity-50 disabled:pointer-event-none",
  primary: "bg-indigo-500 hover:bg-indigo-500/90",
  success: "bg-green-500 hover:bg-green-500/90",
  info: "bg-blue-500 hover:bg-blue-500/90",
  warning: "bg-amber-500 hover:bg-amber-500/90",
  error: "bg-red-500 hover:bg-red-500/90",
  small: "px-2.5 py-1.5 text-xs",
  medium: "px-3.5 py-2 text-sm",
  large: "px-4 py-2 text-base"
}, Zn = go.forwardRef(({ color: e = "primary", size: t = "medium", className: r, ...n }, s) => /* @__PURE__ */ o("button", { ref: s, className: Xn(an(Ke.base, Ke[e], Ke[t], r)), ...n }));
Zn.displayName = "Button";
const fi = ({ value: e, type: t }) => (t === "date" && new Date(e).toLocaleDateString(), e), es = (e = [], t, r) => {
  if (!t || !r) return !1;
  console.log("canAccessService debug:", { permissions: e, serviceName: t, method: r });
  const n = e.some((s) => s.serviceName?.toLowerCase() === t.toLowerCase() && s.method?.toLowerCase() === r.toLowerCase());
  return console.log("canAccessService result:", n), n;
}, bi = {}, D = {
  adminAuthentication: "/admin/authentication",
  adminUsers: "/admin/admin-users",
  clientUsers: "/admin/client-users",
  guardianCustomers: "/admin/guardian-customers",
  roles: "/admin/roles",
  recurringPayments: "/admin/recurring-payments",
  companies: "/admin/companies",
  lob: "/admin/lobs",
  territories: "/admin/territories",
  policies: "/admin/policies",
  recurringPaymentsExecutionLogs: "/admin/recurring-payments-execution-logs",
  troubleshootingGuidelines: "/admin/troubleshooting-guidelines",
  paymentCards: "/admin/payment-cards",
  resources: "/admin/resources",
  applicants: "/application/applicant-profiles",
  customerApplications: "/application/customer-applications",
  riskProfiles: "/application/risk-profiles",
  blacklistRecords: "/admin/blacklist-records",
  signupAttemptHistoryLogs: "/admin/signup-attempt-history-logs",
  workflowItems: "/admin/workflow-items",
  documents: "/application/documents",
  maxSignupRecords: "/admin/max-signup-records",
  auditLogs: "/admin/audit-logs",
  signinAttemptHistoryLogs: "/admin/signin-attempt-history-logs",
  taReports: "/admin/ta-reports",
  sourceSystems: "/admin/source-systems",
  docusign: "/application/docusign",
  orderRecords: "/admin/order-records",
  nonOnlineRenewals: "/admin/non-online-renewals",
  salespalApplications: "/application/salespal-applications",
  manualMerges: "/admin/manual-merges",
  onfidoVerifications: "/application/onfido-verifications",
  manualPaymentExecutionLogs: "/admin/payment-logs",
  bankCards: "/admin/bank-cards",
  facRecords: "/admin/fac-records",
  bankCardStats: "/admin/bank-card-stats"
}, ts = {
  adminUsers: "admin-users",
  clientUsers: "client-users",
  guardianCustomers: "guardian-customers",
  roles: "roles",
  recurringPayments: "recurring-payments",
  policies: "policies",
  recurringPaymentsExecutionLogs: "recurring-payments-execution-logs",
  troubleshootingGuidelines: "troubleshooting-guidelines",
  paymentCards: "payment-cards",
  applicants: "applicant-profiles",
  customerApplications: "customer-applications",
  riskProfiles: "risk-profiles",
  blacklistRecords: "blacklist-records",
  signupAttemptHistoryLogs: "signup-attempt-history-logs",
  documents: "documents",
  maxSignupRecords: "max-signup-records",
  auditLogs: "audit-logs",
  signinAttemptHistoryLogs: "signin-attempt-history-logs",
  taReports: "ta-reports",
  docusign: "docusign",
  orderRecords: "order-records",
  nonOnlineRenewals: "non-online-renewals",
  salespalApplications: "salespal-applications",
  manualMerges: "manual-merges",
  onfidoVerifications: "onfido-verifications",
  manualPaymentExecutionLogs: "payment-logs",
  bankCards: "bank-cards",
  facRecords: "fac-records"
}, os = {
  "admin-users": "Admin Users",
  "applicant-profiles": "Applicant Profiles",
  "audit-logs": "Audit Logs",
  "blacklist-records": "Blacklist Records",
  "client-users": "C360 Login Records",
  "customer-applications": "Customer Applications",
  documents: "Documents",
  docusign: "DocuSign",
  "guardian-customers": "MDM Records",
  "max-signup-records": "Max Signup Records",
  "order-records": "Order Records",
  "non-online-renewals": "Non-Online Renewals",
  "payment-cards": "Payment Cards",
  policies: "Policies",
  "recurring-payments": "Configured Recurring Payments",
  "recurring-payments-execution-logs": "Recurring Payment Execution Logs",
  "risk-profiles": "Risk Profiles",
  roles: "Roles",
  "signin-attempt-history-logs": "Signin Attempt History Logs",
  "signup-attempt-history-logs": "Signup Attempt History Logs",
  "ta-reports": "TA Reports",
  "troubleshooting-guidelines": "Troubleshooting Guidelines",
  "onfido-verifications": "Onfido Verifications"
}, J = ({ label: e, value: t, isLink: r, onLinkClick: n }) => /* @__PURE__ */ o(ce, { size: { xs: 12, sm: 6 }, children: /* @__PURE__ */ f(x, { sx: { display: "flex", flexDirection: "column", gap: 0.25 }, children: [
  /* @__PURE__ */ o(I, { variant: "caption", color: "text.secondary", sx: { fontSize: "0.75rem" }, children: e }),
  r ? /* @__PURE__ */ o(
    br,
    {
      component: "button",
      variant: "body2",
      onClick: n,
      sx: {
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "underline",
        cursor: "pointer",
        textAlign: "left",
        "&:hover": { color: "primary.dark" }
      },
      children: t || "Not specified"
    }
  ) : /* @__PURE__ */ o(I, { variant: "body2", sx: { fontWeight: 500, color: "text.primary" }, children: t || "Not specified" })
] }) }), rs = ({ status: e }) => /* @__PURE__ */ o(de, { label: e || "Unknown", color: ((r) => {
  switch (r?.toLowerCase()) {
    case "active":
      return "success";
    case "failed":
      return "error";
    case "pending":
      return "warning";
    case "paused":
      return "default";
    default:
      return "default";
  }
})(e), size: "small", sx: { fontWeight: 600, textTransform: "capitalize" } }), yi = ({ rowActions: e }) => {
  const t = z(), r = Me(), n = Z(), s = G();
  console.log("record for expand list payments", t);
  const a = async () => {
    if (t?.c360Id)
      try {
        const { data: c } = await n.getList(D.clientUsers, {
          pagination: { page: 1, perPage: 1 },
          sort: { field: "_id", order: "ASC" },
          filter: { "customer.id": t.c360Id }
        });
        if (c && c.length > 0) {
          const i = c[0];
          console.log("guardianCustomer", i), r(`/${D.clientUsers}/${i._id}/show`);
        } else
          console.log("No customer found"), s("No customer found", { type: "warning" });
      } catch (c) {
        console.error("Error fetching customer details", c), s("Error fetching customer details", { type: "error" });
      }
  };
  return t ? /* @__PURE__ */ o(x, { sx: { p: 1, backgroundColor: "#fafbfc", maxWidth: "600px" }, children: /* @__PURE__ */ f(_, { sx: { border: "1px solid #e2e8f0", borderRadius: "8px", boxShadow: 1 }, children: [
    /* @__PURE__ */ f(j, { sx: { padding: "12px !important" }, children: [
      /* @__PURE__ */ f(x, { sx: { display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }, children: [
        /* @__PURE__ */ f(x, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [
          /* @__PURE__ */ o(Fr, { sx: { color: "primary.main", fontSize: 20 } }),
          /* @__PURE__ */ o(I, { variant: "subtitle2", sx: { fontWeight: 600 }, children: "Payment Details" })
        ] }),
        /* @__PURE__ */ o(rs, { status: t.status })
      ] }),
      /* @__PURE__ */ f(ce, { container: !0, spacing: 1.5, children: [
        /* @__PURE__ */ o(J, { label: "C360 ID", value: t.c360Id, isLink: !0, onLinkClick: a }),
        /* @__PURE__ */ o(J, { label: "Master ID", value: t.masterId }),
        /* @__PURE__ */ o(J, { label: "Policy ID", value: t.policyId }),
        /* @__PURE__ */ o(J, { label: "Policy Type", value: t.policyType }),
        /* @__PURE__ */ o(J, { label: "Policy Title", value: t.policyTitle }),
        /* @__PURE__ */ o(J, { label: "Frequency", value: t.frequency }),
        /* @__PURE__ */ o(J, { label: "Country", value: t.country }),
        /* @__PURE__ */ o(J, { label: "Territory", value: t.territory }),
        t.amount && /* @__PURE__ */ o(J, { label: "Amount", value: `${t.currency || ""} ${t.amount}` }),
        t.nextPaymentDate && /* @__PURE__ */ o(J, { label: "Next Payment Date", value: new Date(t.nextPaymentDate).toLocaleDateString() })
      ] })
    ] }),
    e && /* @__PURE__ */ o(
      x,
      {
        sx: {
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          p: 1,
          borderTop: "1px solid #e2e8f0"
        },
        children: e
      }
    )
  ] }) }) : /* @__PURE__ */ o(x, { sx: { p: 2 }, children: /* @__PURE__ */ o(I, { color: "text.secondary", children: "Loading payment details..." }) });
}, ns = () => ({
  nameInitials: {
    cursor: "default"
  }
}), _t = [
  "#F44336",
  "#E91E63",
  "#9C27B0",
  "#673AB7",
  "#3F51B5",
  "#2196F3",
  "#03A9F4",
  "#00BCD4",
  "#009688",
  "#4CAF50",
  "#8BC34A",
  "#CDDC39",
  "#FFEB3B",
  "#FFC107",
  "#FF9800",
  "#FF5722",
  "#795548",
  "#9E9E9E",
  "#607D8B",
  "#F44336",
  "#E91E63",
  "#9C27B0",
  "#673AB7",
  "#3F51B5",
  "#2196F3",
  "#03A9F4",
  "#00BCD4",
  "#009688",
  "#4CAF50",
  "#8BC34A",
  "#CDDC39",
  "#FFEB3B",
  "#FFC107",
  "#FF9800",
  "#FF5722",
  "#795548",
  "#9E9E9E",
  "#607D8B"
], ss = Nr(ns), mt = (e) => {
  const t = ss(), r = (h) => {
    let l = 0;
    for (let m = 0; m < h.length; m++)
      l = h.charCodeAt(m) + ((l << 5) - l);
    return l;
  }, n = (h) => _t[Math.abs(h) % _t.length], s = (h) => h ? h.trim().split(" ").slice(0, 2).map((l) => l?.[0]?.toUpperCase()).join("") : "?", { title: a, src: c, size: i, extraComponent: u, sx: d } = e;
  if (c)
    return /* @__PURE__ */ f(X, { children: [
      /* @__PURE__ */ o(qe, { alt: "Default Avatar", src: c, sx: d, style: { width: i, height: i } }),
      u && u()
    ] });
  const p = s(a);
  return p ? /* @__PURE__ */ f(X, { children: [
    /* @__PURE__ */ o(
      qe,
      {
        alt: "Default Avatar",
        sx: d,
        style: {
          backgroundColor: n(r(p)),
          width: i,
          height: i
        },
        children: /* @__PURE__ */ o("span", { className: t.nameInitials, children: p })
      }
    ),
    u && u()
  ] }) : /* @__PURE__ */ o(
    Er,
    {
      sx: d,
      style: {
        width: i,
        height: i
      }
    }
  );
};
mt.defaultProps = {
  title: "",
  imageSrc: null,
  size: 40,
  extraComponent: () => null
};
mt.propTypes = {
  imageSrc: Ae.string,
  size: Ae.number,
  title: Ae.string,
  extraComponent: Ae.func
};
const $o = ({ size: e = 25, sx: t }) => {
  const r = z();
  return r ? r.avatar ? /* @__PURE__ */ o(qe, { src: `${r.avatar}?size=${e}x${e}`, style: { width: e, height: e }, sx: t, alt: `${r.firstName} ${r.lastName}` }) : /* @__PURE__ */ o(mt, { size: e, sx: t, title: `${r.firstName} ${r.lastName}` }) : null;
}, is = (e) => {
  const { size: t } = e, r = z();
  return r ? /* @__PURE__ */ f(
    I,
    {
      variant: "body2",
      component: "div",
      sx: [
        {
          display: "flex",
          flexWrap: "nowrap",
          alignItems: "center"
        },
        ...Array.isArray(e.sx) ? e.sx : [e.sx]
      ],
      children: [
        r.firstName,
        " ",
        r.lastName
      ]
    }
  ) : null;
}, as = fr(is), xi = () => {
  const e = z();
  return e ? /* @__PURE__ */ o(rt, { to: `/${D.guardianCustomers}/${e.customer.id}`, children: /* @__PURE__ */ o(as, {}) }) : null;
}, ls = Xr("img")({
  width: 25,
  maxWidth: 25,
  maxHeight: 25,
  verticalAlign: "middle"
}), vi = (e) => {
  const t = z();
  return t ? /* @__PURE__ */ o(ls, { src: t.thumbnail, alt: "" }) : null;
}, wi = () => {
  const e = z(), t = te(), r = Zt();
  return e ? /* @__PURE__ */ o(it, { disablePadding: !0, children: /* @__PURE__ */ f(
    at,
    {
      component: rt,
      to: r({
        resource: t,
        type: "edit",
        id: e.id
      }),
      children: [
        /* @__PURE__ */ o(yr, { children: /* @__PURE__ */ o(Ct, { source: "customer.id", reference: "guardian-customers", link: "show", children: /* @__PURE__ */ o($o, { size: 40 }) }) }),
        /* @__PURE__ */ o(
          lt,
          {
            primary: /* @__PURE__ */ o(Ne, { children: /* @__PURE__ */ o(Ct, { source: "customer.id", reference: "guardian-customers", link: "show", children: /* @__PURE__ */ o(eo, { render: (n) => `${n.firstName} ${n.lastName}`, variant: "subtitle1" }) }) }),
            secondary: e.email,
            slotProps: { secondary: { noWrap: !0 } }
          }
        )
      ]
    }
  ) }) : null;
}, le = ({ label: e, source: t }) => /* @__PURE__ */ f(x, { sx: { p: 2, borderRadius: 1, backgroundColor: "grey.50", border: "1px solid", borderColor: "grey.200" }, children: [
  /* @__PURE__ */ o(I, { variant: "caption", color: "text.secondary", sx: { display: "block", mb: 0.5, fontWeight: 600, fontSize: "0.875rem", color: "text.primary" }, children: e }),
  /* @__PURE__ */ o(ve, { source: t })
] }), cs = () => {
  const e = z();
  console.log(`the customer returned from the useRecordContext is ${JSON.stringify(e, null, 2)}`);
  const t = Me();
  return e ? /* @__PURE__ */ f(_, { sx: { borderRadius: 2, boxShadow: 2 }, children: [
    /* @__PURE__ */ o(ue, { title: "Customer Summary", sx: { backgroundColor: "#b54400", color: "white" } }),
    /* @__PURE__ */ o(
      x,
      {
        sx: {
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "right",
          gap: 2
        },
        children: /* @__PURE__ */ o(ot, { variant: "contained", color: "inherit", onClick: () => {
          t(`/${D.clientUsers}/${e.id}/show`);
        }, children: "View Full Customer" })
      }
    ),
    /* @__PURE__ */ o(j, { sx: { p: 3 }, children: /* @__PURE__ */ f(
      x,
      {
        sx: {
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: 2
        },
        children: [
          /* @__PURE__ */ o(le, { label: "Customer ID", source: "customer.id" }),
          /* @__PURE__ */ o(le, { label: "Master ID ", source: "customer.masterId" }),
          /* @__PURE__ */ o(le, { label: "First Name", source: "firstName" }),
          /* @__PURE__ */ o(le, { label: "Last Name", source: "lastName" }),
          /* @__PURE__ */ o(le, { label: "BirthDate", source: "dob" }),
          /* @__PURE__ */ o(le, { label: "Primary Email", source: "email" })
        ]
      }
    ) })
  ] }) : /* @__PURE__ */ o(I, { children: "Loading..." });
}, Ci = () => /* @__PURE__ */ o(
  x,
  {
    sx: {
      maxWidth: "800px",
      px: 2
    },
    children: /* @__PURE__ */ o(
      to,
      {
        reference: D.clientUsers,
        target: "customer.id",
        source: "c360Id",
        link: !1,
        filter: { skipGuardianJoin: !0 },
        empty: /* @__PURE__ */ f(_, { sx: { borderRadius: 2, boxShadow: 2 }, children: [
          /* @__PURE__ */ o(ue, { title: "Customer Summary", sx: { backgroundColor: "#b54400", color: "white" } }),
          /* @__PURE__ */ o(j, { sx: { p: 3, textAlign: "center" }, children: /* @__PURE__ */ o(I, { variant: "body2", sx: { fontWeight: 500, color: "text.primary" }, children: "No active customer found in the database" }) })
        ] }),
        children: /* @__PURE__ */ o(cs, {})
      }
    )
  }
), ds = ({ fieldProps: e, label: t }) => {
  const [r, n] = N("Loading..."), [s, a] = N([]), c = Z(), i = G(), u = Me(), d = z();
  console.log("reached this point to call the custom function"), console.log(`CustomReferenceDisplay - source: ${e?.source}`), console.log(`CustomReferenceDisplay - reference: ${e?.reference}`), console.log(`CustomReferenceDisplay - childSource: ${e?.childSource}`), console.log(`CustomReferenceDisplay - label: ${t}`), V(() => {
    (async () => {
      if (d?.c360Id)
        try {
          const { data: m } = await c.getList(D.clientUsers, {
            pagination: { page: 1, perPage: 1 },
            sort: { field: "_id", order: "ASC" },
            filter: { "customer.id": d.c360Id, skipGuardianJoin: !0 }
          });
          if (m && m.length > 0) {
            a(m);
            const g = m[0];
            console.log(`Guardian Customer ${g}`), n(`${g.firstName} ${g.lastName}`);
          } else
            n("—");
        } catch (m) {
          console.error("Error fetching customer details", m), i("Error fetching customer details", { type: "error" }), n("Error loading");
        }
      else
        n("—");
    })();
  }, [d, c, i]), console.log("CustomerData", JSON.stringify(s, null, 2));
  const p = () => {
    s[0]?._id && u(`${D.clientUsers}/${s[0]._id}/show`);
  };
  return s.length > 0 ? /* @__PURE__ */ o(ve, { source: "displayValue", record: { displayValue: r }, sx: { cursor: "pointer", color: "#1976d2", "&:hover": { textDecoration: "underline" } }, onClick: p }) : r === "Loading..." ? /* @__PURE__ */ o(I, { variant: "body2", color: "text.secondary", children: "Loading..." }) : r === "Error loading" ? /* @__PURE__ */ o(I, { variant: "body2", color: "error", children: "Error loading" }) : /* @__PURE__ */ o(I, { variant: "body2", color: "text.secondary", sx: { fontStyle: "italic", letterSpacing: 0.5 }, children: "—" });
}, us = () => {
  const t = z()?.role;
  if (!t || !Array.isArray(t) || t.length === 0)
    return /* @__PURE__ */ o(ve, { source: "displayValue", record: { displayValue: "No roles assigned" } });
  const r = t.map((n) => typeof n == "string" ? { _id: n, name: n } : n);
  return /* @__PURE__ */ o(x, { sx: { display: "flex", flexWrap: "wrap", gap: 0.5 }, children: r.map((n) => /* @__PURE__ */ o(de, { label: n.name, size: "small" }, n._id)) });
}, ms = ({ label: e }) => {
  const t = z(), [r, n] = N(t?.ticketNumber || "Loading..."), [s, a] = N(null), c = Z(), i = G();
  return Me(), console.log("the record in the ticket reference display", JSON.stringify(t, null, 2)), console.log(`TicketReferenceDisplay - label: ${e}`), V(() => {
    if (t?.ticketNumber) {
      n(t.ticketNumber), a(null);
      return;
    }
    if (t?.status === "success" || t?.errorCode !== "ERR_PARTIAL_MATCH_FAILED")
      return;
    (async () => {
      const h = t?._id;
      if (h)
        try {
          const { data: l } = await c.getList(D.workflowItems, {
            pagination: { page: 1, perPage: 1 },
            sort: { field: "createdAt", order: "DESC" },
            filter: {
              "data.signupLogId": h,
              operation: "submit-alert-failed-signup"
            }
          });
          if (console.log("the data in the ticket reference display", JSON.stringify(l, null, 2)), l && l.length > 0) {
            const m = l[0];
            a(m);
            const g = m.caseId || "No Ticket Number";
            n(g);
          } else
            n("No Ticket Found"), a(null);
        } catch (l) {
          console.error("Error fetching workflow item details", l), i("Error fetching ticket details", { type: "error" }), n("Error loading"), a(null);
        }
      else
        n("No Record Found"), a(null);
    })();
  }, [t, c, i]), !!t?.ticketNumber || t?.status !== "success" && t?.errorCode === "ERR_PARTIAL_MATCH_FAILED" ? /* @__PURE__ */ o(
    ve,
    {
      source: "displayValue",
      record: { displayValue: r }
    }
  ) : /* @__PURE__ */ o(
    I,
    {
      component: "span",
      sx: {
        color: "text.disabled",
        fontSize: "0.875rem",
        fontStyle: "italic",
        userSelect: "none"
      },
      "aria-label": "No ticket number",
      children: "—"
    }
  );
}, pt = (e, t, r = !1) => {
  const { label: n, ...s } = t, a = () => {
    switch (e) {
      case "NumberField":
        return /* @__PURE__ */ o(jo, { ...s });
      case "RoleReferenceDisplay":
        return /* @__PURE__ */ o(us, {});
      case "NameReferenceDisplay":
        return /* @__PURE__ */ o(ds, { fieldProps: s, label: n });
      case "TicketReferenceDisplay":
        return /* @__PURE__ */ o(ms, { label: n });
      case "SelectField":
        return /* @__PURE__ */ o(_o, { ...s });
      case "DateField":
        return /* @__PURE__ */ o(Oo, { ...s });
      case "AvatarField":
        return /* @__PURE__ */ o($o, { ...s });
      case "FunctionField":
        return /* @__PURE__ */ o(eo, { ...s });
      case "ArrayField":
        return /* @__PURE__ */ o(Wo, { ...s });
      case "BooleanField":
        return /* @__PURE__ */ o(Uo, { ...s });
      default:
        return /* @__PURE__ */ o(ve, { ...s });
    }
  };
  return r && n ? /* @__PURE__ */ f(x, { sx: { mb: 1 }, children: [
    /* @__PURE__ */ o(
      I,
      {
        variant: "body2",
        sx: {
          fontWeight: 600,
          mb: 0.5,
          color: "text.primary",
          fontSize: "0.875rem"
        },
        children: n
      }
    ),
    /* @__PURE__ */ o(x, { sx: { "& .MuiTypography-root": { fontSize: "1rem", fontWeight: 400 } }, children: a() })
  ] }) : a();
}, ps = {
  find: "View list",
  get: "View details",
  create: "Create",
  // update: 'Update',
  patch: "Update",
  delete: "Delete",
  fullAccess: "Full Access",
  approve: "Approve",
  reject: "Reject",
  return: "Return",
  undo: "Undo",
  flagForResend: "Resend",
  manualUpdate: "Manual Update",
  revertManualUpdate: "Undo Manual Update"
}, gs = (e) => ps[e] || e.charAt(0).toUpperCase() + e.slice(1), hs = (e) => (console.log("serviceName: ", e), os[e] || e), fs = () => /* @__PURE__ */ o(Q, { spacing: 2, "aria-busy": "true", "aria-label": "Loading permissions", children: Array.from({ length: 3 }).map((e, t) => /* @__PURE__ */ f(ho, { elevation: 0, sx: { border: "1px solid", borderColor: "divider", borderRadius: 2, p: 3 }, children: [
  /* @__PURE__ */ f(x, { sx: { display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }, children: [
    /* @__PURE__ */ o(Be, { animation: "wave", variant: "text", width: 200, height: 28 }),
    /* @__PURE__ */ o(Be, { animation: "wave", variant: "rounded", width: 96, height: 30 })
  ] }),
  /* @__PURE__ */ o(me, { sx: { mb: 2 } }),
  /* @__PURE__ */ o(
    x,
    {
      sx: {
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
        gap: 1.5
      },
      children: Array.from({ length: 6 }).map((r, n) => /* @__PURE__ */ o(Be, { animation: "wave", variant: "rounded", height: 40, sx: { borderRadius: 1 } }, n))
    }
  )
] }, t)) }), bs = (e) => {
  const { field: t } = oo(e), { disabled: r = !1 } = e, n = Array.isArray(t.value) ? t.value : [], [s, a] = N([]), [c, i] = N(!0), u = Z();
  console.log("permisssions are", JSON.stringify(n, null, 2)), V(() => {
    let l = !1;
    const m = new Set(Object.values(ts)), g = 50, b = async () => {
      const y = [];
      let C = 1, R = 1 / 0;
      for (; y.length < R; ) {
        const P = await u.getList(D.resources, {
          pagination: { page: C, perPage: g },
          sort: { field: "serviceName", order: "ASC" },
          filter: {}
        }), A = Array.isArray(P?.data) ? P.data : [];
        if (y.push(...A), R = Number.isFinite(P?.total) ? P.total : y.length, A.length === 0) break;
        C += 1;
      }
      return Array.from(
        new Map(
          y.filter((P) => P && m.has(P.serviceName)).map((P) => [P.serviceName, P])
        ).values()
      );
    };
    return i(!0), b().then((y) => {
      l || (console.log("Resources loaded (filtered):", y), a(
        y.map((C) => ({ ...C, methods: C.methods.filter((R) => R !== "update") }))
      ));
    }).catch((y) => {
      l || console.error("Error loading resources:", y);
    }).finally(() => {
      l || i(!1);
    }), () => {
      l = !0;
    };
  }, [u]);
  const d = (l) => n.filter((m) => m.serviceName === l.serviceName).length, p = (l) => l.methods.every((m) => n.some((g) => g.serviceName === l.serviceName && g.method === m)), h = (l, m) => {
    if (m) {
      const g = l.methods.map((y) => ({
        serviceName: l.serviceName,
        method: y
      })), b = n.filter((y) => y.serviceName !== l.serviceName);
      t.onChange([...b, ...g]);
    } else
      t.onChange(n.filter((g) => g.serviceName !== l.serviceName));
  };
  return /* @__PURE__ */ f(x, { sx: { width: "100%" }, children: [
    /* @__PURE__ */ f(x, { sx: { mb: 3 }, children: [
      /* @__PURE__ */ o(
        I,
        {
          variant: "subtitle1",
          sx: {
            fontWeight: 600,
            color: "text.primary",
            mb: 1
          },
          children: r ? "Permissions" : "Select Permissions"
        }
      ),
      /* @__PURE__ */ o(I, { variant: "body2", color: "text.secondary", children: r ? "View assigned permissions for this role" : "Choose which methods each service can access" })
    ] }),
    c ? /* @__PURE__ */ o(fs, {}) : /* @__PURE__ */ o(Q, { spacing: 2, children: s.map((l) => {
      const m = d(l), g = p(l);
      return /* @__PURE__ */ f(
        ho,
        {
          elevation: 0,
          sx: {
            border: "1px solid",
            borderColor: m > 0 ? "primary.light" : "divider",
            borderRadius: 2,
            p: 3,
            transition: "all 0.2s ease-in-out",
            backgroundColor: m > 0 ? Re("#1976d2", 0.02) : "background.paper",
            "&:hover": {
              borderColor: "primary.main",
              boxShadow: "0 2px 8px 0 rgba(0,0,0,0.08)"
            }
          },
          children: [
            /* @__PURE__ */ f(
              x,
              {
                sx: {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mb: 2
                },
                children: [
                  /* @__PURE__ */ f(x, { sx: { display: "flex", alignItems: "center", gap: 2 }, children: [
                    /* @__PURE__ */ o(
                      I,
                      {
                        variant: "h6",
                        sx: {
                          fontSize: "1.1rem",
                          fontWeight: 600,
                          color: "text.primary"
                        },
                        children: hs(l.serviceName)
                      }
                    ),
                    m > 0 && /* @__PURE__ */ o(de, { label: `${m} selected`, size: "small", color: "primary", sx: { fontWeight: 500 } })
                  ] }),
                  /* @__PURE__ */ o(
                    Qe,
                    {
                      control: /* @__PURE__ */ o(Fe, { disabled: r, checked: g, indeterminate: m > 0 && !g, onChange: (b) => h(l, b.target.checked), sx: { "& .MuiSvgIcon-root": { fontSize: 22 } } }),
                      label: /* @__PURE__ */ o(I, { variant: "body2", sx: { fontWeight: 500 }, children: "Select All" })
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ o(me, { sx: { mb: 2 } }),
            /* @__PURE__ */ o(
              x,
              {
                sx: {
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "1fr",
                    sm: "repeat(2, 1fr)",
                    md: "repeat(3, 1fr)"
                  },
                  gap: 1.5
                },
                children: l.methods.map((b) => {
                  const y = n.some((C) => C.serviceName === l.serviceName && C.method === b);
                  return /* @__PURE__ */ o(
                    Qe,
                    {
                      control: /* @__PURE__ */ o(
                        Fe,
                        {
                          disabled: r,
                          checked: y,
                          onChange: (C) => {
                            C.target.checked ? t.onChange([...n, { serviceName: l.serviceName, method: b }]) : t.onChange(n.filter((R) => !(R.serviceName === l.serviceName && R.method === b)));
                          }
                        }
                      ),
                      label: /* @__PURE__ */ o(
                        I,
                        {
                          variant: "body2",
                          sx: {
                            fontWeight: y ? 500 : 400,
                            color: y ? "text.primary" : "text.secondary"
                          },
                          children: gs(b)
                        }
                      ),
                      sx: {
                        border: "1px solid",
                        borderColor: y ? "primary.main" : "divider",
                        borderRadius: 1,
                        px: 1.5,
                        py: 0.5,
                        m: 0,
                        backgroundColor: y ? Re("#1976d2", 0.04) : "transparent",
                        transition: "all 0.15s ease-in-out",
                        "&:hover": {
                          backgroundColor: y ? Re("#1976d2", 0.08) : Re("#000", 0.02),
                          borderColor: "primary.main"
                        }
                      }
                    },
                    b
                  );
                })
              }
            )
          ]
        },
        l._id
      );
    }) })
  ] });
}, ys = ({ source: e, label: t, reference: r, dependsOnField: n, filterKey: s, optionText: a, optionValue: c, ...i }) => /* @__PURE__ */ o(ro, { children: ({ formData: u }) => {
  const d = u[n];
  console.log("DependentReferenceArrayInput - FormData:", u), console.log("DependentReferenceArrayInput - dependsOnField:", n), console.log("DependentReferenceArrayInput - watchedValue:", d);
  const p = d && d.length > 0 ? { [s]: { $in: d } } : { _id: "000000000000000000000000" };
  return console.log("DependentReferenceArrayInput - filterKey:", s), console.log("DependentReferenceArrayInput - filter:", p), /* @__PURE__ */ o(no, { source: e, label: t, reference: r, filter: p, ...i, children: /* @__PURE__ */ o(so, { optionText: a, optionValue: c }) });
} }), xs = ({ source: e, label: t, dependsOnField: r }) => {
  const {
    field: { onChange: n, value: s }
  } = oo({ source: e }), [a, c] = N(null), i = Array.isArray(s) ? s : [], u = (p) => {
    n([...i, { company: p, lob: [] }]), c(null);
  }, d = (p) => {
    n(i.filter((h) => h.company !== p));
  };
  return /* @__PURE__ */ o(ro, { children: ({ formData: p }) => {
    const h = p[r], l = h?.length > 0 ? { territories: { $in: h } } : { _id: "000000000000000000000000" }, { data: m } = fe(D.companies, {
      filter: l,
      pagination: { page: 1, perPage: 100 }
    }), g = m?.filter((b) => !i.find((y) => y.company === b._id)) || [];
    return /* @__PURE__ */ f(x, { sx: { mb: 2 }, children: [
      /* @__PURE__ */ f(x, { sx: { display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }, children: [
        /* @__PURE__ */ o(I, { variant: "subtitle2", children: t }),
        h?.length > 0 && g.length > 0 && /* @__PURE__ */ o(be, { size: "small", startIcon: /* @__PURE__ */ o(zr, {}), onClick: (b) => c(b.currentTarget), variant: "outlined", children: "Add Company" })
      ] }),
      !h?.length && /* @__PURE__ */ o(I, { variant: "body2", color: "text.secondary", sx: { fontStyle: "italic" }, children: "Select territories first" }),
      /* @__PURE__ */ o(xr, { anchorEl: a, open: !!a, onClose: () => c(null), children: g.map((b) => /* @__PURE__ */ o(vr, { onClick: () => u(b._id), children: b.name }, b._id)) }),
      /* @__PURE__ */ o(x, { sx: { display: "flex", flexDirection: "column", gap: 1 }, children: i.map((b, y) => /* @__PURE__ */ o(
        vs,
        {
          item: b,
          onUpdate: (C) => {
            const R = [...i];
            R[y] = { ...b, lob: C }, n(R);
          },
          onRemove: () => d(b.company)
        },
        y
      )) })
    ] });
  } });
}, vs = ({ item: e, onUpdate: t, onRemove: r }) => {
  const [n, s] = N(!1), { data: a } = fe(D.companies, { filter: { _id: e.company }, pagination: { page: 1, perPage: 1 } }), { data: c } = fe(D.lob, { filter: { companies: { $in: [e.company] } }, pagination: { page: 1, perPage: 50 } }), i = a?.[0];
  return /* @__PURE__ */ o(_, { variant: "outlined", sx: { "&:hover": { bgcolor: "action.hover" } }, children: /* @__PURE__ */ f(j, { sx: { p: 1.5, "&:last-child": { pb: 1.5 } }, children: [
    /* @__PURE__ */ f(x, { sx: { display: "flex", alignItems: "center", justifyContent: "space-between", mb: n ? 1 : 0 }, children: [
      /* @__PURE__ */ f(x, { sx: { display: "flex", alignItems: "center", gap: 1, flex: 1 }, children: [
        /* @__PURE__ */ o(I, { variant: "body2", sx: { fontWeight: 500 }, children: i?.name || "Loading..." }),
        /* @__PURE__ */ o(de, { label: `${e.lob.length}/${c?.length || 0}`, size: "small", color: e.lob.length > 0 ? "primary" : "default" })
      ] }),
      /* @__PURE__ */ f(x, { sx: { display: "flex", gap: 0.5 }, children: [
        /* @__PURE__ */ o(Ee, { size: "small", onClick: () => s(!n), sx: { p: 0.5 }, children: n ? /* @__PURE__ */ o($r, { fontSize: "small" }) : /* @__PURE__ */ o(xo, { fontSize: "small" }) }),
        /* @__PURE__ */ o(Ee, { size: "small", color: "error", onClick: r, sx: { p: 0.5 }, children: /* @__PURE__ */ o(Mr, { fontSize: "small" }) })
      ] })
    ] }),
    /* @__PURE__ */ o(fo, { in: n, children: /* @__PURE__ */ o(ct, { dense: !0, disablePadding: !0, sx: { maxHeight: 200, overflow: "auto", mt: 0.5 }, children: c?.map((u) => /* @__PURE__ */ f(
      at,
      {
        onClick: () => {
          const d = e.lob.includes(u._id) ? e.lob.filter((p) => p !== u._id) : [...e.lob, u._id];
          t(d);
        },
        dense: !0,
        sx: { py: 0.5, px: 1, borderRadius: 0.5 },
        children: [
          /* @__PURE__ */ o(Fe, { size: "small", checked: e.lob.includes(u._id), sx: { p: 0, mr: 1 } }),
          /* @__PURE__ */ o(lt, { primary: u.name, slotProps: { primary: { variant: "body2" } } })
        ]
      },
      u._id
    )) }) })
  ] }) });
}, jt = (e) => {
  const { type: t, ...r } = e;
  switch (t) {
    case "NumberInput":
      return /* @__PURE__ */ o(co, { ...r });
    case "SelectInput":
      return /* @__PURE__ */ o(nt, { ...r });
    case "SelectArrayInput":
      return /* @__PURE__ */ o(so, { ...r });
    case "DateInput":
      return /* @__PURE__ */ o(ao, { ...r });
    case "AutocompleteInput":
      return /* @__PURE__ */ o(uo, { ...r });
    default:
      return /* @__PURE__ */ o(io, { ...r });
  }
}, Mo = (e, t) => {
  switch (e) {
    case "NumberInput":
      return /* @__PURE__ */ o(co, { ...t });
    case "ReferenceInput":
      return /* @__PURE__ */ o(lo, { ...t, ...t?.referenceDetails, children: /* @__PURE__ */ o(jt, { ...t?.childReferenceDetails }) });
    case "SelectInput":
      return /* @__PURE__ */ o(nt, { ...t });
    // case 'SelectArrayInput':
    //   return <SelectArrayInput {...props} />;
    case "ReferenceArrayInput":
      return /* @__PURE__ */ o(no, { ...t, ...t?.referenceDetails, children: /* @__PURE__ */ o(jt, { ...t?.otherRefenceDetails }) });
    case "DateInput":
      return /* @__PURE__ */ o(ao, { ...t });
    case "PermissionSelector":
      return /* @__PURE__ */ o(bs, { ...t });
    case "DependentReferenceArrayInput":
      return /* @__PURE__ */ o(ys, { ...t });
    case "CompanyLobSelector":
      return /* @__PURE__ */ o(xs, { ...t });
    default:
      return /* @__PURE__ */ o(io, { ...t });
  }
}, ki = ({ title: e, icon: t, children: r, sx: n = {} }) => {
  const s = Zr();
  return /* @__PURE__ */ o(
    _,
    {
      elevation: 0,
      sx: {
        height: "100%",
        position: "relative",
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        borderLeftWidth: 4,
        borderLeftColor: "primary.main",
        /* Faint brand tint — matches admin default (#f7f5fb) + MuiCard primary border feel */
        backgroundColor: H(s.palette.primary.main, s.palette.mode === "dark" ? 0.12 : 0.042),
        backgroundImage: `linear-gradient(
          165deg,
          ${H(s.palette.background.paper, s.palette.mode === "dark" ? 0.14 : 0.72)} 0%,
          ${H(s.palette.primary.main, s.palette.mode === "dark" ? 0.06 : 0.028)} 100%
        )`,
        boxShadow: `0 1px 2px ${H(s.palette.common.black, 0.04)}, 0 6px 20px ${H(s.palette.common.black, 0.06)}`,
        transition: s.transitions.create(["box-shadow", "border-color"], {
          duration: s.transitions.duration.shorter
        }),
        "&:hover": {
          boxShadow: `0 2px 8px ${H(s.palette.common.black, 0.06)}, 0 12px 28px ${H(s.palette.common.black, 0.08)}`,
          borderColor: H(s.palette.divider, s.palette.mode === "dark" ? 1 : 0.95)
        },
        ...n
      },
      children: /* @__PURE__ */ f(j, { sx: { p: 2.75, "&:last-child": { pb: 2.75 } }, children: [
        /* @__PURE__ */ f(
          x,
          {
            sx: {
              display: "flex",
              alignItems: "center",
              gap: 1.25,
              pb: 2,
              mb: 2,
              borderBottom: "1px solid",
              borderColor: "divider"
            },
            children: [
              /* @__PURE__ */ o(
                x,
                {
                  sx: {
                    width: 40,
                    height: 40,
                    borderRadius: 1.5,
                    display: "grid",
                    placeItems: "center",
                    flexShrink: 0,
                    backgroundColor: H(s.palette.primary.main, 0.1),
                    color: "primary.main",
                    border: "1px solid",
                    borderColor: H(s.palette.primary.main, 0.18),
                    "& .MuiSvgIcon-root": { fontSize: "1.35rem" }
                  },
                  children: t
                }
              ),
              /* @__PURE__ */ o(
                I,
                {
                  variant: "subtitle1",
                  component: "h3",
                  sx: {
                    fontWeight: 600,
                    color: "text.primary",
                    letterSpacing: "0.01em",
                    lineHeight: 1.35
                  },
                  children: e
                }
              )
            ]
          }
        ),
        r
      ] })
    }
  );
}, Si = ({ label: e, value: t, isLink: r = !1, color: n = "text.primary", onClick: s, showNavigationIcon: a = !1, onNavigate: c }) => /* @__PURE__ */ f(x, { sx: { mb: 1.75 }, children: [
  /* @__PURE__ */ o(
    I,
    {
      variant: "overline",
      sx: {
        color: "text.secondary",
        fontWeight: 600,
        letterSpacing: "0.08em",
        lineHeight: 1.6
      },
      children: e
    }
  ),
  /* @__PURE__ */ f(x, { sx: { display: "flex", alignItems: "center", gap: 1, justifyContent: "space-between" }, children: [
    /* @__PURE__ */ o(
      I,
      {
        variant: "body2",
        onClick: s,
        sx: {
          color: n,
          fontWeight: 500,
          fontSize: "0.98rem",
          lineHeight: 1.55,
          flex: 1,
          wordBreak: "break-word",
          ...r && {
            color: "primary.main",
            cursor: "pointer",
            textDecoration: "none",
            "&:hover": { textDecoration: "underline" }
          }
        },
        children: t
      }
    ),
    a && c && /* @__PURE__ */ o(
      Ee,
      {
        size: "small",
        onClick: c,
        "aria-label": "Open details",
        sx: {
          ml: 0.5,
          p: 0.5,
          borderRadius: 1,
          border: "1px solid",
          borderColor: "divider",
          transition: "all 140ms ease",
          "&:hover": {
            backgroundColor: "primary.main",
            borderColor: "primary.main",
            color: "primary.contrastText"
          }
        },
        children: /* @__PURE__ */ o(Ur, { fontSize: "small" })
      }
    )
  ] })
] }), ws = ({ label: e, value: t, color: r = "text.primary" }) => /* @__PURE__ */ f(
  x,
  {
    sx: {
      px: 2,
      py: 1.5,
      borderRadius: 1.5,
      border: "1px solid",
      borderColor: "divider",
      bgcolor: "white"
    },
    children: [
      /* @__PURE__ */ o(
        I,
        {
          variant: "caption",
          sx: {
            display: "block",
            mb: 0.5,
            fontSize: "0.75rem",
            color: "text.secondary",
            letterSpacing: 0.2,
            textTransform: "uppercase"
          },
          children: e
        }
      ),
      /* @__PURE__ */ o(
        I,
        {
          variant: "body1",
          sx: {
            fontWeight: 600,
            color: r,
            wordBreak: "break-word"
          },
          children: t
        }
      )
    ]
  }
), Cs = ({ title: e, subtitle: t, headerIcon: r, fields: n, statusChip: s, actionButton: a }) => {
  const c = z(), i = Jr(), u = () => {
    c && i(a.getPath(c));
  }, d = n(c);
  return /* @__PURE__ */ f(
    _,
    {
      elevation: 1,
      sx: {
        borderRadius: 2,
        borderColor: "divider"
      },
      children: [
        /* @__PURE__ */ o(
          ue,
          {
            avatar: r,
            title: e,
            subheader: t,
            action: s ? /* @__PURE__ */ o(
              de,
              {
                label: s.label,
                size: "small",
                sx: {
                  backgroundColor: s.color,
                  color: "white",
                  fontWeight: 500
                }
              }
            ) : void 0,
            sx: {
              bgcolor: "background.default",
              borderBottom: "1px solid",
              borderColor: "divider"
            }
          }
        ),
        /* @__PURE__ */ o(
          j,
          {
            sx: {
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" },
              gap: 2
            },
            children: d.map((p, h) => /* @__PURE__ */ o(ws, { label: p.label, value: p.value, color: p.color }, h))
          }
        ),
        /* @__PURE__ */ o(me, {}),
        /* @__PURE__ */ o(wr, { sx: { px: 3, pb: 3 }, children: /* @__PURE__ */ o(
          be,
          {
            variant: "contained",
            onClick: u,
            fullWidth: !0,
            sx: {
              py: 1.5,
              fontWeight: 600,
              textTransform: "none"
            },
            children: a.label
          }
        ) })
      ]
    }
  );
}, Ii = ({ reference: e, source: t, target: r, title: n, subtitle: s, headerIcon: a, fields: c, statusChip: i, actionButton: u, emptyMessage: d = "No record found in the database", filter: p }) => /* @__PURE__ */ o(x, { children: /* @__PURE__ */ o(
  to,
  {
    source: t,
    reference: e,
    target: r,
    link: !1,
    filter: p,
    label: !1,
    empty: /* @__PURE__ */ f(
      _,
      {
        elevation: 0,
        sx: {
          borderRadius: 2,
          border: "1px dashed",
          borderColor: "divider",
          bgcolor: "background.paper"
        },
        children: [
          /* @__PURE__ */ o(
            ue,
            {
              avatar: a,
              title: n,
              sx: {
                bgcolor: "background.default",
                borderBottom: "1px solid",
                borderColor: "divider"
              }
            }
          ),
          /* @__PURE__ */ o(j, { sx: { textAlign: "center" }, children: /* @__PURE__ */ o(I, { variant: "body2", sx: { color: "text.secondary" }, children: d }) })
        ]
      }
    ),
    children: /* @__PURE__ */ o(Cs, { title: n, subtitle: s, headerIcon: a, fields: c, statusChip: i, actionButton: u })
  }
) }), ks = ({ children: e, sort: t, total: r, bulkActionButtons: n, rowSx: s, onLoading: a, empty: c, rowClick: i }) => {
  const { isLoading: u } = se();
  return go.useEffect(() => {
    a && a(u ?? !1);
  }, [u, a]), u ? /* @__PURE__ */ o(x, { sx: { display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200, p: 4 }, children: /* @__PURE__ */ o($e, {}) }) : (console.log("sort in DatagridWithLoading: ", t), /* @__PURE__ */ o(
    Go,
    {
      sx: {
        "& .RaDatagrid-rowEven": { bgcolor: "background.default" }
      },
      sort: t,
      total: r,
      rowClick: i,
      bulkActionButtons: n,
      rowSx: (d) => ({
        "&:hover": { bgcolor: "action.hover" },
        transition: (p) => p.transitions.create("background-color", {
          duration: p.transitions.duration.shortest
        }),
        ...s ? s(d) : {}
      }),
      empty: c,
      children: e
    }
  ));
}, Ss = (e) => /* @__PURE__ */ o(Vo, { rowsPerPageOptions: [5, 10, 25, 50, 100, 150, 200], ...e }), Ri = ({ title: e, description: t, reference: r, target: n, source: s, sort: a, total: c, perPage: i = 50, children: u, rowSx: d, bulkActionButtons: p = !1, onLoading: h, filter: l, empty: m, rowClick: g }) => {
  const b = m || /* @__PURE__ */ o(
    x,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 200,
        p: 4,
        textAlign: "center"
      },
      children: /* @__PURE__ */ f(
        x,
        {
          sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
            maxWidth: 400
          },
          children: [
            /* @__PURE__ */ o(
              x,
              {
                sx: {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 64,
                  height: 64,
                  borderRadius: "50%",
                  bgcolor: "action.hover",
                  color: "text.secondary",
                  mb: 1
                },
                children: /* @__PURE__ */ o(Wr, { sx: { fontSize: 32 } })
              }
            ),
            /* @__PURE__ */ o(I, { variant: "h6", sx: { fontWeight: 500, color: "text.primary", mb: 0.5 }, children: "No results found" })
          ]
        }
      )
    }
  );
  return /* @__PURE__ */ f(
    _,
    {
      elevation: 1,
      sx: {
        width: "100%",
        borderRadius: 2,
        borderColor: "divider"
      },
      children: [
        (e || t) && /* @__PURE__ */ f(X, { children: [
          /* @__PURE__ */ o(ue, { title: e, subheader: t, slotProps: { title: { variant: "h6" }, subheader: { variant: "body2", color: "text.secondary" } } }),
          /* @__PURE__ */ o(me, {})
        ] }),
        /* @__PURE__ */ o(j, { sx: { p: 0 }, children: /* @__PURE__ */ o(Bo, { source: s, reference: r, target: n, perPage: i > 50 ? 50 : i, filter: l, sort: a, pagination: i > 50 ? /* @__PURE__ */ o(Ss, {}) : void 0, children: /* @__PURE__ */ o(ks, { sort: a, total: c, bulkActionButtons: p, rowSx: d, onLoading: h, empty: b, rowClick: g, children: u }) }) })
      ]
    }
  );
}, ye = ({ html: e, variant: t = "body1", sx: r, ...n }) => e ? /* @__PURE__ */ o(
  I,
  {
    variant: t,
    component: "div",
    sx: {
      // Strip the outer margins TipTap wraps around block content so the text
      // aligns with the surrounding MUI layout.
      "& > :first-of-type": { mt: 0 },
      "& > :last-child": { mb: 0 },
      "& p": { my: 1 },
      "& ul, & ol": { my: 1, pl: 3 },
      "& a": { color: "primary.main" },
      "& code": { px: 0.5, borderRadius: 0.5, backgroundColor: "grey.100", fontFamily: "monospace", fontSize: "0.9em" },
      ...r
    },
    dangerouslySetInnerHTML: { __html: e },
    ...n
  }
) : null, Is = {
  CHECK_DATABASE: /* @__PURE__ */ o(Kr, { color: "primary" }),
  CHECK_LOGS: /* @__PURE__ */ o(Hr, { color: "info" }),
  UPDATE_RECORD: /* @__PURE__ */ o(Vr, { color: "warning" }),
  CONTACT_CUSTOMER: /* @__PURE__ */ o(Gr, { color: "success" })
}, Rs = {
  CRITICAL: "error",
  HIGH: "warning",
  MEDIUM: "info",
  LOW: "success"
}, As = {
  CUSTOMER: /* @__PURE__ */ o(jr, { color: "primary" }),
  PAYMENT: /* @__PURE__ */ o(_r, { color: "success" })
}, ge = ({ title: e, children: t }) => /* @__PURE__ */ f(x, { component: "section", children: [
  /* @__PURE__ */ o(
    I,
    {
      variant: "overline",
      sx: {
        display: "block",
        mb: 1.5,
        pb: 0.75,
        color: "primary.main",
        fontWeight: 700,
        letterSpacing: "0.08em",
        borderBottom: "2px solid",
        borderColor: "primary.light"
      },
      children: e
    }
  ),
  t
] }), Je = ({ items: e }) => /* @__PURE__ */ o(x, { component: "ul", sx: { m: 0, pl: 2.25, listStyleType: "disc" }, children: e.map((t, r) => /* @__PURE__ */ o(
  x,
  {
    component: "li",
    sx: {
      mb: 1.25,
      "&:last-of-type": { mb: 0 },
      "&::marker": { color: "primary.main", fontSize: "0.6em" }
    },
    children: /* @__PURE__ */ o(ye, { html: t, variant: "body2", sx: { lineHeight: 1.6, "& p": { my: 0 }, "& p + p": { mt: 1 } } })
  },
  r
)) }), Bt = ({ steps: e }) => /* @__PURE__ */ o(Cr, { orientation: "vertical", nonLinear: !0, children: e.map((t, r) => /* @__PURE__ */ f(kr, { active: !0, expanded: !0, children: [
  /* @__PURE__ */ o(Sr, { icon: Is[t.actionType] ?? /* @__PURE__ */ o(Br, { color: "disabled" }), children: /* @__PURE__ */ o(ye, { html: t.instruction, variant: "body2", fontWeight: 600 }) }),
  /* @__PURE__ */ o(Ir, { children: /* @__PURE__ */ o(ye, { html: t.details, variant: "body2", color: "text.secondary" }) })
] }, r)) }), De = ({ severity: e, title: t, children: r }) => /* @__PURE__ */ o(x, { sx: { p: 3 }, children: /* @__PURE__ */ f(bo, { severity: e, variant: "outlined", children: [
  /* @__PURE__ */ o(yo, { sx: { fontWeight: 600 }, children: t }),
  /* @__PURE__ */ o(I, { variant: "body2", children: r })
] }) }), Ai = ({ subModule: e } = {}) => {
  const t = z(), r = t?.status === "failed", n = t?.processStatus, s = t?.errorCode, a = t?.facIsoResponseCode, c = n != null, i = s != null, u = c ? n : i ? s : "N/A", d = e ? { processStatus: n, subModule: e } : { processStatus: n }, p = c && i ? { $or: [d, { errorCode: s }] } : c ? d : i ? { errorCode: s } : {}, { data: h, isLoading: l, error: m } = fe(D.troubleshootingGuidelines, { filter: p, pagination: { page: 1, perPage: 10 } }, { enabled: r && (c || i) });
  return r ? !c && !i ? /* @__PURE__ */ o(De, { severity: "info", title: "No Troubleshooting Context", children: "There is no process status or error code available to match troubleshooting guidelines." }) : l ? /* @__PURE__ */ f(Q, { direction: "row", spacing: 2, alignItems: "center", justifyContent: "center", sx: { p: 4 }, children: [
    /* @__PURE__ */ o($e, { size: 24 }),
    /* @__PURE__ */ o(I, { variant: "body2", color: "text.secondary", children: "Loading troubleshooting guidelines..." })
  ] }) : m ? /* @__PURE__ */ o(De, { severity: "error", title: "Error Loading Guidelines", children: "Unable to load troubleshooting guidelines. Please try refreshing the page." }) : h?.length ? /* @__PURE__ */ f(Q, { spacing: 3, sx: { p: 3 }, children: [
    /* @__PURE__ */ f(x, { children: [
      /* @__PURE__ */ f(Q, { direction: "row", spacing: 2, alignItems: "center", sx: { mb: 2 }, children: [
        /* @__PURE__ */ o(Ft, { color: "error", sx: { fontSize: 32 } }),
        /* @__PURE__ */ f(x, { children: [
          /* @__PURE__ */ o(I, { variant: "h5", fontWeight: 700, children: "Troubleshooting Guidelines" }),
          /* @__PURE__ */ f(I, { variant: "body2", color: "text.secondary", children: [
            "Context Value: ",
            String(u),
            " • Execution Status: Failed"
          ] })
        ] })
      ] }),
      /* @__PURE__ */ f(bo, { severity: "error", variant: "outlined", children: [
        /* @__PURE__ */ o(yo, { sx: { fontWeight: 600 }, children: "Execution Failed" }),
        /* @__PURE__ */ o(I, { variant: "body2", children: "This operation failed and requires attention. Follow the guidelines below to diagnose and resolve the issue." })
      ] })
    ] }),
    h.map((g) => {
      const b = g.subTypeMapping?.find((y) => y.conditionField === "facIsoResponseCode" && y.conditionValue === a);
      return /* @__PURE__ */ o(_, { variant: "outlined", sx: { borderRadius: 2, overflow: "hidden" }, children: /* @__PURE__ */ f(j, { sx: { p: 0 }, children: [
        /* @__PURE__ */ o(x, { sx: { p: 3, bgcolor: "action.hover", borderBottom: "1px solid", borderColor: "divider" }, children: /* @__PURE__ */ f(Q, { direction: "row", spacing: 2, alignItems: "flex-start", justifyContent: "space-between", children: [
          /* @__PURE__ */ f(Q, { direction: "row", spacing: 2, alignItems: "center", children: [
            As[g.category] ?? /* @__PURE__ */ o(Ft, { color: "disabled" }),
            /* @__PURE__ */ f(x, { children: [
              /* @__PURE__ */ f(I, { variant: "h6", fontWeight: 700, sx: { lineHeight: 1.3 }, children: [
                g.title,
                b && ` • ${b.specificGuidance.title}`
              ] }),
              /* @__PURE__ */ o(I, { variant: "body2", color: "text.secondary", sx: { mt: 0.25 }, children: [g.processStatusName, g.category].filter(Boolean).join(" • ") })
            ] })
          ] }),
          /* @__PURE__ */ o(de, { label: g.priority, color: Rs[g.priority] ?? "default", size: "small", sx: { fontWeight: 700, flexShrink: 0 } })
        ] }) }),
        /* @__PURE__ */ f(Q, { spacing: 4, sx: { p: 3 }, children: [
          g.description && /* @__PURE__ */ o(ge, { title: "Description", children: /* @__PURE__ */ o(ye, { html: g.description, variant: "body2", sx: { lineHeight: 1.7 } }) }),
          g.commonCauses?.length > 0 && /* @__PURE__ */ o(ge, { title: "Common Causes", children: /* @__PURE__ */ o(Je, { items: g.commonCauses }) }),
          g.diagnosticSteps?.length > 0 && /* @__PURE__ */ o(ge, { title: "Diagnostic Steps", children: /* @__PURE__ */ o(Bt, { steps: g.diagnosticSteps }) }),
          /* @__PURE__ */ o(ge, { title: "Resolution Steps", children: g.resolutionSteps?.length > 0 ? /* @__PURE__ */ o(Bt, { steps: g.resolutionSteps }) : /* @__PURE__ */ o(I, { variant: "body2", color: "text.secondary", sx: { fontStyle: "italic" } }) }),
          b && /* @__PURE__ */ f(
            x,
            {
              component: "section",
              sx: {
                borderRadius: 2,
                border: "1px solid",
                borderColor: "warning.main",
                borderLeft: "6px solid",
                borderLeftColor: "warning.main",
                bgcolor: "warning.50",
                boxShadow: (y) => `0 0 0 1px ${y.palette.warning.light}`,
                p: 3
              },
              children: [
                /* @__PURE__ */ f(Q, { direction: "row", spacing: 1.5, alignItems: "center", sx: { mb: 2 }, children: [
                  /* @__PURE__ */ o(Or, { color: "warning" }),
                  /* @__PURE__ */ f(x, { children: [
                    /* @__PURE__ */ f(I, { variant: "overline", sx: { display: "block", lineHeight: 1.2, color: "warning.dark", fontWeight: 700, letterSpacing: "0.08em" }, children: [
                      "Specific Guidance for ISO Code: ",
                      a
                    ] }),
                    /* @__PURE__ */ o(I, { variant: "caption", color: "text.secondary", children: "Matched to this exact error — start here." })
                  ] })
                ] }),
                /* @__PURE__ */ o(I, { variant: "subtitle1", fontWeight: 700, gutterBottom: !0, children: b.specificGuidance.title }),
                /* @__PURE__ */ o(ye, { html: b.specificGuidance.description, variant: "body2", sx: { lineHeight: 1.7 } }),
                b.specificGuidance.additionalSteps?.length > 0 && /* @__PURE__ */ f(x, { sx: { mt: 2 }, children: [
                  /* @__PURE__ */ o(I, { variant: "caption", color: "warning.dark", fontWeight: 700, sx: { display: "block", mb: 1, textTransform: "uppercase", letterSpacing: "0.06em" }, children: "Additional Steps" }),
                  /* @__PURE__ */ o(Je, { items: b.specificGuidance.additionalSteps })
                ] })
              ]
            }
          ),
          g.preventionTips?.length > 0 && /* @__PURE__ */ o(ge, { title: "Prevention Tips", children: /* @__PURE__ */ o(Je, { items: g.preventionTips }) })
        ] })
      ] }) }, g._id);
    })
  ] }) : /* @__PURE__ */ o(De, { severity: "warning", title: "No Guidelines Found", children: "No troubleshooting guidelines were found for this error." }) : /* @__PURE__ */ o(De, { severity: "success", title: "Execution Status: Success", children: "This item completed successfully. No troubleshooting is needed." });
}, Ts = ({ fields: e }) => {
  const t = z(), r = te(), n = Zt();
  return t ? /* @__PURE__ */ o(it, { disablePadding: !0, children: /* @__PURE__ */ o(
    at,
    {
      component: rt,
      to: n({
        resource: r,
        type: "show",
        id: t.id
      }),
      children: /* @__PURE__ */ o(
        lt,
        {
          primary: /* @__PURE__ */ o(Ne, { children: e?.map(({ componentName: s, ...a }) => {
            const c = pt(s, a, !1);
            return /* @__PURE__ */ o(X, { children: c });
          }) }),
          secondary: t.id,
          slotProps: { secondary: { noWrap: !0 } }
        }
      )
    }
  ) }) : null;
}, Ti = ({ open: e, onClose: t }) => {
  const r = z();
  console.log(JSON.stringify(r));
  const { data: n, isLoading: s } = fe(D.roles, {
    pagination: { page: 1, perPage: 100 },
    sort: { field: "name", order: "ASC" }
  }), [a, c] = N([]), i = (m) => {
    a.includes(m) ? c(a.filter((g) => g !== m)) : c([...a, m]);
  };
  V(() => {
    if (r?.role && Array.isArray(r.role)) {
      const m = r.role.map((g) => g._id);
      c(m), console.log(`selected roles are ${a}`);
    }
  }, [r, e]);
  const [u] = tt(), d = G(), [p, h] = N(!1), l = async () => {
    if (r?._id) {
      h(!0);
      try {
        await u(D.adminUsers, {
          id: r._id,
          data: { role: a },
          //update the user roles
          previousData: r
        }), d("Roles updated successfully", { type: "success" }), t();
      } catch {
        d("Error updated successfully", { type: "error" });
      } finally {
        h(!1);
      }
    }
  };
  return /* @__PURE__ */ f(Rr, { open: e, onClose: t, children: [
    /* @__PURE__ */ f(Ar, { children: [
      "Assigning Roles to ",
      r?.firstName,
      " ",
      r?.lsatName
    ] }),
    /* @__PURE__ */ o(Tr, { children: s ? /* @__PURE__ */ o($e, {}) : /* @__PURE__ */ o(ct, { children: n?.map((m) => /* @__PURE__ */ o(it, { children: /* @__PURE__ */ o(
      Qe,
      {
        control: /* @__PURE__ */ o(
          Fe,
          {
            checked: a.includes(m._id),
            onChange: () => i(m._id)
          }
        ),
        label: m.name
      }
    ) }, m._id)) }) }),
    /* @__PURE__ */ f(Pr, { children: [
      /* @__PURE__ */ o(be, { onClick: t, children: "Cancel " }),
      /* @__PURE__ */ o(be, { variant: "contained", onClick: l, disabled: p, children: p ? "Saving..." : "Save" })
    ] })
  ] });
}, Pi = () => {
  const e = Z(), t = localStorage.getItem("userId");
  console.log("useUserCompanyChoices - userId: ", t);
  const [r, n] = N([]), [s, a] = N(!1);
  return V(() => {
    if (console.log("useUserCompanyChoices - useEffect userId: ", t), !t) {
      console.log("useUserCompanyChoices - no userId, clearing choices"), n([]);
      return;
    }
    (async () => {
      a(!0), console.log("useUserCompanyChoices - loading companies for", t);
      try {
        const i = await e.getOne(D.adminUsers, { id: t });
        console.log("useUserCompanyChoices - admin user", i?.data);
        const d = (i?.data?.companies || []).map((l) => l.company).filter(Boolean);
        if (console.log("useUserCompanyChoices - company ids", d), d.length === 0) {
          console.log("useUserCompanyChoices - no companies on user"), n([]);
          return;
        }
        const p = await e.getList(D.companies, {
          pagination: { page: 1, perPage: d.length },
          sort: { field: "name", order: "ASC" },
          filter: { _id: { $in: d } }
        });
        console.log("useUserCompanyChoices - company records", p?.data);
        const h = (p?.data || []).map((l) => ({
          id: l.code?.toLowerCase?.() || l.code,
          name: l.name ? `${l.name} (${l.code})` : l.code,
          raw: l
        }));
        console.log("useUserCompanyChoices - choices", h), n(h);
      } catch (i) {
        console.error("Failed to load user company choices:", i), n([]);
      } finally {
        a(!1);
      }
    })();
  }, [e, t]), { choices: r, isLoading: s };
}, Di = () => {
  const e = Z(), t = localStorage.getItem("userId");
  console.log("useUserTerritoryChoices - userId: ", t);
  const [r, n] = N([]), [s, a] = N(!1);
  return V(() => {
    if (console.log("useUserTerritoryChoices - useEffect userId: ", t), !t) {
      console.log("useUserTerritoryChoices - no userId, clearing choices"), n([]);
      return;
    }
    (async () => {
      a(!0), console.log("useUserTerritoryChoices - loading territories for", t);
      try {
        const i = await e.getOne(D.adminUsers, { id: t });
        console.log("useUserTerritoryChoices - admin user", i?.data);
        const d = (i?.data?.territories || []).map((l) => l && typeof l == "object" ? l?._id : l).filter(Boolean);
        if (console.log("useUserTerritoryChoices - territory ids", d), d.length === 0) {
          console.log("useUserTerritoryChoices - no territories on user"), n([]);
          return;
        }
        const p = await e.getList(D.territories, {
          pagination: { page: 1, perPage: d.length },
          sort: { field: "title", order: "ASC" },
          filter: { _id: { $in: d } }
        });
        console.log("useUserTerritoryChoices - territory records", p?.data);
        const h = (p?.data || []).map((l) => ({
          id: l.alpha2 || l._id,
          name: `${l.title} (${l.alpha2})`,
          alpha3Long: l.alpha3 || l.code || "",
          raw: l
        }));
        console.log("useUserTerritoryChoices - choices", h), n(h);
      } catch (i) {
        console.error("Failed to load user territory choices:", i), n([]);
      } finally {
        a(!1);
      }
    })();
  }, [e, t]), { choices: r, isLoading: s };
}, Li = () => {
  const e = Z(), t = localStorage.getItem("userId"), [r, n] = N([]), [s, a] = N(!1);
  return V(() => {
    if (!t) {
      console.log("useUserSourceSystems - no userId, clearing choices");
      return;
    }
    (async () => {
      a(!0);
      try {
        const d = ((await e.getOne(D.adminUsers, { id: t }))?.data?.companies || []).map((l) => l.company).filter(Boolean);
        if (console.log("useUseCompanyChoices - company ids", d), d.length === 0)
          return;
        const p = await e.getList(D.sourceSystems, {
          pagination: { page: 1, perPage: 50 },
          filter: { companies: { $in: d }, allowPostingToSource: !0 }
        });
        console.log("useUserSourceSystems - source systems", p?.data);
        const h = (p?.data || []).map((l) => ({
          id: l.name,
          name: l.name,
          raw: l
        }));
        console.log("useUserSourceSystems - next choices", h), n(h);
      } catch (i) {
        console.error("Failed to load user source systems:", i), n([]);
      } finally {
        a(!1);
      }
    })();
  }, [e, t]), { choices: r, isLoading: s };
}, Ni = () => {
  const e = Z(), t = localStorage.getItem("userId");
  console.log("useUserLobChoices - userId: ", t);
  const [r, n] = N([]), [s, a] = N(!1);
  return V(() => {
    if (console.log("useUserLobChoices - useEffect userId", t), !t)
      return;
    (async () => {
      a(!0);
      try {
        const i = await e.getOne(D.adminUsers, { id: t });
        console.log("useUserLobChoices - admin user", i?.data);
        const u = i?.data?.companies || [];
        console.log("useUserLobChoices - companies", JSON.stringify(u, null, 2));
        const d = Array.from(new Set(u.flatMap((l) => l?.lob || []).filter((l) => typeof l == "string" && l.trim().length > 0)));
        if (console.log("useUserLobChoices - lob ids", d), d.length === 0) {
          console.log("useUserLobChoices - no lob ids on user");
          return;
        }
        const p = await e.getList(D.lob, {
          pagination: { page: 1, perPage: d.length },
          filter: { _id: { $in: d } }
        });
        console.log("useUserLobChoices - lob records", p?.data);
        const h = (p?.data || []).map((l) => ({
          id: l.code,
          name: l.name,
          raw: l
        }));
        console.log("useUserLobChoices - choices", h), n(h);
      } catch (i) {
        console.error("Failed to load user lob choices:", i), n([]);
      } finally {
        a(!1);
      }
    })();
  }, [e, t]), { choices: r, isLoading: s };
}, Fi = () => {
  const e = Z(), t = localStorage.getItem("userId"), [r, n] = N([]), [s, a] = N(!1);
  return V(() => {
    if (!t)
      return;
    (async () => {
      a(!0);
      try {
        const i = await e.getOne(D.adminUsers, { id: t });
        console.log("adminUserResult: ", i?.data);
        const u = i?.data?.role || [];
        if (console.log("roleIds: ", u), u.length === 0) {
          n([]);
          return;
        }
        n(u);
      } catch (i) {
        console.error("Failed to load user roles:", i), n([]);
      } finally {
        a(!1);
      }
    })();
  }, [e, t]), { roles: r, isLoading: s };
};
function Ps(e) {
  return {
    list: "find",
    show: "get",
    create: "create",
    edit: "patch",
    delete: "remove"
  }[e] || e;
}
const Ds = {
  "applicant-profiles": "/application/",
  "customer-applications": "/application/",
  "risk-profiles": "/application/",
  documents: "/application/",
  docusign: "/application/",
  /** application-api proxied UI resource; matches `resources.salespalApplications` */
  "salespal-applications": "/application/",
  "onfido-verifications": "/application/"
  // Add more mappings here, e.g.:
  // 'api-service-1': '/api/',
  // 'public-service-1': '/public/',
};
function he(e) {
  return `${Ds[e.toLowerCase()] || "/admin/"}${e}`;
}
function Ls() {
  if (typeof window > "u")
    return null;
  const e = window.location.hash.match(/access_token=([^&]+)/);
  if (e?.[1])
    return decodeURIComponent(e[1]);
  const t = window.location.search.match(/access_token=([^&]+)/);
  return t?.[1] ? decodeURIComponent(t[1]) : null;
}
function Ns() {
  if (!(typeof window > "u")) {
    if (window.location.hash.includes("access_token=")) {
      window.history.replaceState(null, "", `${window.location.pathname}#/`);
      return;
    }
    if (window.location.search.includes("access_token=")) {
      const e = new URLSearchParams(window.location.search);
      e.delete("access_token"), e.delete("token_type"), e.delete("expires_in");
      const t = e.toString();
      window.history.replaceState(null, "", `${window.location.pathname}${t ? `?${t}` : ""}${window.location.hash}`);
    }
  }
}
function Gt(e) {
  try {
    const t = Le(e);
    if (!t.exp) return !1;
    const r = Math.floor(Date.now() / 1e3);
    return t.exp < r;
  } catch (t) {
    return console.error("Error decoding token:", t), !0;
  }
}
const Ei = (e, t) => {
  const { storageKey: r, authenticate: n, permissionsKey: s, permissionsField: a, passwordField: c, usernameField: i, redirectTo: u, logoutOnForbidden: d, idKey: p, authServiceName: h } = Object.assign(
    {},
    {
      storageKey: "feathers-jwt",
      authenticate: { strategy: "local" },
      permissionsKey: "permissions",
      permissionsField: "roles",
      passwordField: "password",
      usernameField: "email",
      redirectTo: "/login",
      logoutOnForbidden: !0,
      idKey: "sub",
      authServiceName: D.adminUsers
    },
    t
  );
  return {
    // send username and password to the auth server and get back credentials
    async login(m) {
      const { username: g, password: b, accessToken: y, strategy: C } = m, R = await e.authenticate(
        y || C === "jwt" ? { strategy: "jwt", accessToken: y } : {
          ...n,
          [i]: g,
          [c]: b
        }
      );
      console.log("response from login is  ", R);
      const P = R.user?._id || R.user?.id;
      console.log("userId from login is  ", P);
      const A = R.user.role, L = A.map((O) => ({
        ...O,
        permissions: O.permissions.map(($) => ({
          ...$,
          serviceName: he($.serviceName)
        }))
      }));
      return console.log("All permissions:", L), console.log("userRolesAndPermissions from login is  ", A), localStorage.setItem(s, JSON.stringify(L)), localStorage.setItem(r, R.accessToken), localStorage.setItem("userId", P), Promise.resolve();
    },
    // when the dataProvider returns an error, check if this is an authentication error
    async checkError(m) {
      const { code: g } = m;
      return g === 401 || g === 403 && d ? (localStorage.removeItem(r), localStorage.removeItem(s), Promise.reject()) : Promise.resolve();
    },
    // when the user navigates, make sure that their credentials are still valid
    async checkAuth(m) {
      console.log("checkAuth params: ", m);
      const g = Ls();
      if (!localStorage.getItem(r) && g) {
        if (Gt(g))
          return Promise.reject({ redirectTo: u });
        Ns(), localStorage.setItem(r, g), window.location.href = "/#";
        try {
          const y = await e.authenticate({ strategy: "jwt", accessToken: g }), C = y?.user?._id || y?.user?.id;
          localStorage.setItem("userId", C);
          const P = (y?.user?.role || []).map((A) => ({
            ...A,
            permissions: A.permissions.map((L) => ({
              ...L,
              serviceName: he(L.serviceName)
            }))
          }));
          localStorage.setItem(s, JSON.stringify(P));
        } catch (y) {
          return console.error("Failed to fetch permissions during SSO:", y), localStorage.removeItem(r), localStorage.removeItem(s), Promise.reject({ redirectTo: u });
        }
      }
      const b = localStorage.getItem(r);
      if (console.log("token from localStorage: ", JSON.stringify(b)), !b)
        return Promise.reject({ redirectTo: u });
      if (Gt(b))
        return localStorage.removeItem(r), localStorage.removeItem(s), Promise.reject({ redirectTo: u });
      if (!localStorage.getItem(s))
        try {
          const R = ((await e.authenticate({ strategy: "jwt", accessToken: b }))?.user?.role || []).map((P) => ({
            ...P,
            permissions: P.permissions.map((A) => ({
              ...A,
              serviceName: he(A.serviceName)
            }))
          }));
          localStorage.setItem(s, JSON.stringify(R));
        } catch (y) {
          return console.error("Failed to fetch permissions during checkAuth:", y), localStorage.removeItem(r), localStorage.removeItem(s), Promise.reject({ redirectTo: u });
        }
      return Promise.resolve();
    },
    // remove local credentials and notify the auth server that the user logged out
    async logout() {
      localStorage.removeItem(r), localStorage.removeItem(s);
      try {
        await e.logout();
      } catch (m) {
        console.log("Logout error (ignored):", m);
      }
      return Promise.resolve();
    },
    // get the user's profile
    async getIdentity() {
      try {
        console.log("getIdentity localStorage.getItem(storageKey");
        const m = localStorage.getItem(r), g = Le(m);
        console.log("getIdentity decodedToken: ", g);
        const b = await e.service(h).get(g[p]), { _id: y, firstName: C, lastName: R, email: P, avatar: A } = b;
        return console.log(`getIdentity UserService user name is ${C} ${R}`), Promise.resolve({ id: y, firstName: C, lastName: R, email: P, avatar: A });
      } catch {
        return Promise.reject();
      }
    },
    async canAccess({ action: m, resource: g }) {
      try {
        let b = JSON.parse(localStorage.getItem(s));
        if (!b && localStorage.getItem(r))
          try {
            const C = localStorage.getItem(r);
            if (C) {
              await e.authenticate({ strategy: "jwt", accessToken: C });
              const P = Le(C).sub;
              b = ((await e.service(h).get(P)).role || []).map((O) => ({
                ...O,
                permissions: O.permissions?.map(($) => ({
                  ...$,
                  serviceName: he($.serviceName)
                })) || []
              })), localStorage.setItem(s, JSON.stringify(b));
            }
          } catch (C) {
            console.error("Failed to fetch permissions for SSO:", C);
          }
        const y = Ps(m);
        return console.log("canAccess debug:", { action: m, resource: g, serviceAction: y, permissions: b }), b && b.some((C) => es(C.permissions, g, y));
      } catch (b) {
        return console.error("Error in canAccess:", b), !1;
      }
    },
    async getPermissions() {
      const m = localStorage.getItem(r);
      if (!m) return Promise.reject();
      try {
        await e.authenticate({ strategy: "jwt", accessToken: m });
        const b = Le(m).sub;
        console.log("adminUsers", D.adminUsers);
        const C = (await e.service(D.adminUsers).get(b)).role;
        console.log("User roles:", C);
        const R = C.map((P) => ({
          ...P,
          permissions: P.permissions.map((A) => ({
            ...A,
            serviceName: he(A.serviceName)
          }))
        }));
        return console.log("All permissions:", R), R;
      } catch (g) {
        return console.error("Error in getPermissions:", g), Promise.reject();
      }
    }
  };
}, q = "id", Vt = ["$gt", "$gte", "$lt", "$lte", "$ne", "$sort", "$or", "$nin", "$in"];
function Ze(e, t = "", r = []) {
  return Object.keys(e).reduce((n, s) => e[s] && typeof e[s] == "object" && !Array.isArray(e[s]) && !Object.keys(e[s]).some((c) => r.includes(c)) ? { ...n, ...Ze(e[s], `${t}${s}.`, r) } : { ...n, [`${t}${s}`]: e[s] }, {});
}
function Ht({ resource: e, options: t }) {
  return t[e] && t[e].id || t.idKey || q;
}
function Ye(e, t) {
  const r = Object.assign({}, e);
  return delete r[t], r;
}
const Fs = ["fromDate", "toDate", "nextPaymentAttemptFrom", "nextPaymentAttemptTo"];
function Kt(e) {
  if (!e || typeof e != "object") return e;
  const t = { ...e };
  for (const r of Fs) {
    const n = t[r];
    if (typeof n == "string" && n) {
      const s = new Date(n);
      Number.isNaN(s.getTime()) || (t[r] = s.toISOString());
    }
  }
  return t;
}
const zi = (e, t) => {
  const r = !!t.usePatch, n = (a, c, i) => {
    const u = Ht({ resource: c, options: t }), d = e.service(c), p = {};
    switch (a) {
      case Lt: {
        const A = i.ids || [];
        return p[u] = { $in: A }, p.$limit = A.length, d.find({ query: p });
      }
      case Dt:
        if (i.target && i.id && (p[i.target] = i.id), i.pagination) {
          const { page: A, perPage: L } = i.pagination;
          L && A && (p.$limit = L, p.$skip = L * (A - 1));
        }
        if (i.sort) {
          const { field: A, order: L } = i.sort;
          L && (p.$sort = {
            [A === q ? u : A]: L === "DESC" ? -1 : 1
          });
        }
        if (i.filter) {
          const A = Array.isArray(t.customQueryOperators) ? t.customQueryOperators : [], L = [...new Set(Vt.concat(A))];
          Object.assign(p, Ze(Kt(i.filter), "", L));
        }
        return d.find({ query: p });
      case Pt:
        const { page: h, perPage: l } = i.pagination || {}, { field: m, order: g } = i.sort || {}, b = Array.isArray(t.customQueryOperators) ? t.customQueryOperators : [], y = [...new Set(Vt.concat(b))];
        return l && h && (p.$limit = l, p.$skip = l * (h - 1)), g && (p.$sort = {
          [m === q ? u : m]: g === "DESC" ? -1 : 1
        }), Object.assign(p, i.filter ? Ze(Kt(i.filter), "", y) : {}), d.find({ query: p });
      case Tt:
        const C = Ye(i, q);
        return d.get(i.id, C);
      case At:
        if (r) {
          const A = i.previousData ? Et(i.previousData, i.data) : i.data;
          return d.patch(i.id, A);
        }
        const R = u !== q ? Ye(i.data, q) : i.data;
        return d.update(i.id, R);
      case Rt:
        if (r) {
          const A = i.previousData ? Et(i.previousData, i.data) : i.data;
          return Promise.all(i.ids.map((L) => d.patch(L, A)));
        }
        const P = u !== q ? Ye(i.data, q) : i.data;
        return Promise.all(i.ids.map((A) => d.update(A, P)));
      case It:
        return d.create(i.data);
      case St:
        return d.remove(i.id);
      case kt:
        return t.useMulti && d.options.multi ? d.remove(null, {
          query: {
            [u]: {
              $in: i.ids
            }
          }
        }) : Promise.all(i.ids.map((A) => d.remove(A)));
      default:
        return Promise.reject(`Unsupported FeathersJS restClient action type ${a}`);
    }
  }, s = (a, c, i, u) => {
    const d = Ht({ resource: i, options: t });
    switch (c) {
      case Tt:
      case At:
      case St:
        return { data: { ...a, id: a[d] } };
      case Rt:
      case kt:
        return { data: a.map((h) => h[d]) };
      case It:
        return { data: { ...u.data, ...a, id: a[d] } };
      case Dt:
      // fix GET_MANY_REFERENCE missing id
      case Lt:
      // fix GET_MANY missing id
      case Pt:
        let p;
        return a.data ? p = a.data : (a.total = a.length, p = a), a.data = p.map((h) => {
          const l = h;
          return d !== q && (l.id = h[d]), h;
        }), a;
      default:
        return a;
    }
  };
  return (a, c, i) => n(a, c, i).then((u) => s(u, a, c, i));
}, Es = () => {
  const e = st(), { defaultTitle: t } = Ko();
  return /* @__PURE__ */ f(X, { children: [
    /* @__PURE__ */ o("title", { children: `${e} - ${t}` }),
    /* @__PURE__ */ f(x, { sx: { mb: 2 }, children: [
      /* @__PURE__ */ o(
        I,
        {
          variant: "h4",
          component: "h1",
          sx: {
            fontWeight: 600,
            color: "text.primary",
            mb: 1
          },
          children: t
        }
      ),
      /* @__PURE__ */ o(me, { sx: { borderColor: "primary.main", borderWidth: 2, width: "60px" } })
    ] })
  ] });
}, $i = ({ fields: e, redirectUrl: t, successMessage: r = "Record was created successfully", ...n }) => {
  const s = G(), a = xe();
  return /* @__PURE__ */ o(
    x,
    {
      sx: {
        backgroundColor: "grey.50",
        minHeight: "100vh",
        py: 3
      },
      children: /* @__PURE__ */ o(
        Ho,
        {
          ...n,
          mutationOptions: { onSuccess: (i) => {
            s(r), t && a(t);
          } },
          title: /* @__PURE__ */ o(Es, {}),
          sx: {
            "& .RaCreate-main": {
              backgroundColor: "transparent"
            },
            "& .RaCreate-card": {
              boxShadow: "none",
              backgroundColor: "transparent",
              border: "none"
            }
          },
          children: /* @__PURE__ */ o(
            _,
            {
              elevation: 2,
              sx: {
                maxWidth: "800px",
                mx: "auto",
                borderRadius: 3,
                overflow: "visible",
                backgroundColor: "white"
              },
              children: /* @__PURE__ */ o(j, { sx: { p: 4 }, children: /* @__PURE__ */ o(
                mo,
                {
                  defaultValues: {},
                  sx: {
                    "& .MuiCardContent-root": {
                      pb: "16px !important"
                    },
                    "& .RaSimpleForm-form": {
                      backgroundColor: "transparent"
                    }
                  },
                  children: /* @__PURE__ */ o(
                    ce,
                    {
                      container: !0,
                      spacing: 3,
                      sx: {
                        mt: 0
                      },
                      children: e?.map(({ size: i = { xs: 12, sm: 6 }, componentName: u, ...d }, p) => {
                        const h = Mo(u, d);
                        return /* @__PURE__ */ o(
                          ce,
                          {
                            size: i,
                            sx: {
                              "& .MuiFormControl-root": {
                                width: "100%"
                              },
                              "& .MuiInputBase-root": {
                                backgroundColor: "white",
                                borderRadius: 2,
                                "&:hover": {
                                  backgroundColor: "grey.50"
                                },
                                "&.Mui-focused": {
                                  backgroundColor: "white"
                                }
                              },
                              "& .MuiInputLabel-root": {
                                fontWeight: 500,
                                color: "text.secondary"
                              }
                            },
                            children: h
                          },
                          p
                        );
                      })
                    }
                  )
                }
              ) })
            }
          )
        }
      )
    }
  );
}, zs = ({ redirectUrl: e, successMessage: t = "Record was updated successfully", errorMessage: r = "Record was not updated", label: n = "Accept" }) => {
  const s = te(), a = xe(), c = G(), i = z();
  return i ? /* @__PURE__ */ o(
    Yr,
    {
      sx: {
        display: "flex",
        justifyContent: "space-between",
        minHeight: { sm: 0 }
      },
      children: i.status === "pending" ? /* @__PURE__ */ f(Ne, { children: [
        /* @__PURE__ */ o(en, {}),
        /* @__PURE__ */ o(sn, {})
      ] }) : /* @__PURE__ */ f(Ne, { children: [
        /* @__PURE__ */ o(
          Jo,
          {
            label: n,
            mutationOptions: {
              onSuccess: () => {
                c(t, {
                  type: "info",
                  messageArgs: { smart_count: 1 },
                  undoable: !0
                }), e && a(e);
              },
              onError: () => {
                c(r, {
                  type: "error"
                });
              }
            },
            type: "button"
          }
        ),
        /* @__PURE__ */ o(Yo, { record: i, resource: s })
      ] })
    }
  ) : null;
}, $s = () => {
  const e = st(), { defaultTitle: t } = Qo();
  return /* @__PURE__ */ f(X, { children: [
    /* @__PURE__ */ o("title", { children: `${e} - ${t}` }),
    /* @__PURE__ */ f(x, { sx: { mb: 2 }, children: [
      /* @__PURE__ */ o(
        I,
        {
          variant: "h4",
          component: "h1",
          sx: {
            fontWeight: 300,
            color: "text.secondary",
            mb: 1
          },
          children: "Edit Record"
        }
      ),
      /* @__PURE__ */ o(me, { sx: { borderColor: "primary.main", borderWidth: 2, width: "60px" } })
    ] })
  ] });
}, Ms = () => /* @__PURE__ */ f(Xo, { children: [
  /* @__PURE__ */ o(Zo, {}),
  /* @__PURE__ */ o(er, {}),
  /* @__PURE__ */ o(tr, {}),
  /* @__PURE__ */ o(or, {})
] }), Mi = ({ fields: e, resource: t, redirectUrl: r, successMessage: n = "Record was updated" }) => {
  et();
  const s = G(), a = xe();
  return /* @__PURE__ */ o(
    x,
    {
      sx: {
        backgroundColor: "grey.50",
        minHeight: "100vh",
        py: 3
      },
      children: /* @__PURE__ */ f(
        qo,
        {
          resource: t,
          actions: /* @__PURE__ */ o(Ms, {}),
          redirect: "list",
          mutationOptions: { onSuccess: (i) => {
            console.log("it reached here"), s(n), r && a(r);
          } },
          mutationMode: "pessimistic",
          sx: {
            "& .RaEdit-main": {
              backgroundColor: "transparent"
            },
            "& .RaEdit-card": {
              boxShadow: "none",
              backgroundColor: "transparent",
              border: "none"
            }
          },
          children: [
            /* @__PURE__ */ o($s, {}),
            /* @__PURE__ */ o(
              _,
              {
                elevation: 2,
                sx: {
                  maxWidth: "800px",
                  ml: 0,
                  borderRadius: 3,
                  overflow: "visible",
                  backgroundColor: "white"
                },
                children: /* @__PURE__ */ o(j, { sx: { p: 4 }, children: /* @__PURE__ */ o(
                  mo,
                  {
                    sx: {
                      pt: 0,
                      pb: 0,
                      "& .MuiCardContent-root": {
                        pb: "16px !important"
                      },
                      "& .RaSimpleForm-form": {
                        backgroundColor: "transparent"
                      }
                    },
                    toolbar: /* @__PURE__ */ o(zs, {}),
                    children: /* @__PURE__ */ o(
                      ce,
                      {
                        container: !0,
                        spacing: 3,
                        sx: {
                          mt: 0
                        },
                        children: e?.map(({ size: i = { xs: 12, sm: 6 }, componentName: u, ...d }, p) => {
                          const h = Mo(u, d);
                          return /* @__PURE__ */ o(
                            ce,
                            {
                              size: i,
                              sx: {
                                "& .MuiFormControl-root": {
                                  width: "100%"
                                },
                                "& .MuiInputBase-root": {
                                  backgroundColor: "white",
                                  borderRadius: 2,
                                  "&:hover": {
                                    backgroundColor: "grey.50"
                                  },
                                  "&.Mui-focused": {
                                    backgroundColor: "white"
                                  }
                                },
                                "& .MuiInputLabel-root": {
                                  fontWeight: 500,
                                  color: "text.secondary"
                                }
                              },
                              children: h
                            },
                            p
                          );
                        })
                      }
                    )
                  }
                ) })
              }
            )
          ]
        }
      )
    }
  );
}, Us = ({ fields: e }) => {
  const { data: t, error: r, isPending: n, total: s } = se();
  return n || r || Number(s) === 0 ? null : /* @__PURE__ */ o(ct, { sx: { width: "100%" }, children: t.map((a) => /* @__PURE__ */ o(rr, { value: a, children: /* @__PURE__ */ o(Ts, { fields: e }) }, a.id)) });
}, Ws = () => /* @__PURE__ */ f(X, { children: [
  /* @__PURE__ */ o(on, {}),
  /* @__PURE__ */ o(nn, {}),
  /* @__PURE__ */ o(nr, {})
] }), Os = po, Jt = po.Col, _s = "__rowActions", js = ({ fields: e, rowActions: t, expandListComponent: r, disableBulkActions: n }) => /* @__PURE__ */ o(
  x,
  {
    sx: {
      width: "100%",
      maxWidth: "100%",
      // When many columns, scroll horizontally so the actions column is never clipped off-screen
      overflowX: "auto",
      overflowY: "visible",
      // Present the table as a self-contained, lightly elevated card
      border: "1px solid #e2e8f0",
      borderRadius: 2,
      boxShadow: "0 1px 2px rgba(16, 24, 40, 0.04), 0 1px 3px rgba(16, 24, 40, 0.06)"
    },
    children: /* @__PURE__ */ f(
      Os,
      {
        expand: r || !1,
        size: "medium",
        rowClick: !1,
        bulkActionButtons: n ? !1 : /* @__PURE__ */ o(Ws, {}),
        sx: {
          minWidth: "100%",
          width: "max-content",
          // No maxWidth here — table can grow past the card; outer Box provides overflow-x: auto
          "& .RaDataTable-table": {
            borderCollapse: "collapse",
            tableLayout: "auto",
            width: "max-content",
            minWidth: "100%"
          },
          "& .RaDataTable-thead th": {
            backgroundColor: "#f8fafc",
            borderBottom: "1px solid #e2e8f0",
            py: 1.25,
            px: 2,
            fontWeight: 600,
            fontSize: 12,
            letterSpacing: "0.04em",
            textTransform: "uppercase",
            color: "#64748b",
            textAlign: "left",
            whiteSpace: "nowrap"
          },
          // Clear affordance for the active/hovered sort column
          "& .RaDataTable-thead th .MuiTableSortLabel-root:hover": {
            color: "#334155"
          },
          "& .RaDataTable-thead th .MuiTableSortLabel-root.Mui-active": {
            color: "#1e293b"
          },
          "& .RaDataTable-thead th .MuiTableSortLabel-icon": {
            color: "inherit !important",
            opacity: 0.9
          },
          "& .RaDataTable-tbody td": {
            py: 1.25,
            px: 2,
            borderBottom: "1px solid #f1f5f9",
            fontSize: 14,
            color: "#334155",
            verticalAlign: "middle",
            maxWidth: 220,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          },
          // Zebra striping + smooth hover for easier row scanning
          "& .RaDataTable-tbody tr": {
            transition: "background-color 120ms ease"
          },
          "& .RaDataTable-tbody tr:nth-of-type(even)": {
            backgroundColor: "#fcfcfd"
          },
          "& .RaDataTable-tbody tr:hover": {
            backgroundColor: "#f1f5f9"
          },
          // Highlight rows picked via the bulk-select checkboxes
          "& .RaDataTable-tbody tr.Mui-selected, & .RaDataTable-tbody tr.Mui-selected:hover": {
            backgroundColor: "#eff6ff"
          },
          "& .RaDataTable-tbody tr:last-of-type td": {
            borderBottom: "none"
          },
          "& .RaDataTable-container": {
            overflow: "visible"
          }
        },
        children: [
          e?.map(({ componentName: s, ...a }) => {
            const { label: c, source: i, sortable: u } = a;
            return /* @__PURE__ */ o(Jt, { label: c, source: i, disableSort: u === !1, children: pt(s, a, !1) }, String(i));
          }),
          t ? /* @__PURE__ */ o(
            Jt,
            {
              source: _s,
              label: "Actions",
              disableSort: !0,
              sx: {
                minWidth: 140,
                width: "auto",
                maxWidth: "none !important",
                overflow: "visible !important",
                textOverflow: "clip",
                whiteSpace: "nowrap",
                // Inherit the row background so zebra striping / hover stay consistent
                backgroundColor: "inherit",
                borderLeft: "1px solid #e2e8f0",
                pl: 2,
                pr: 2,
                "&.MuiTableCell-head": { backgroundColor: "#f8fafc" }
              },
              children: /* @__PURE__ */ o(x, { component: "span", sx: { display: "inline-flex", flexWrap: "nowrap", alignItems: "center", columnGap: 0.5 }, children: t })
            }
          ) : null
        ]
      }
    )
  }
), Bs = ({ filterColumns: e }) => {
  const { filterValues: t, setFilters: r } = se(), [n, s] = N(/* @__PURE__ */ new Set()), a = (l, m) => {
    const g = { ...t };
    m && m.trim() ? g[l] = m.trim() : delete g[l], r(g, []);
  }, c = () => {
    const l = /* @__PURE__ */ new Date(), m = l.getFullYear(), g = String(l.getMonth() + 1).padStart(2, "0"), b = String(l.getDate()).padStart(2, "0");
    return `${m}-${g}-${b}`;
  }, i = (l, m, g) => {
    const b = { ...t }, y = `${l}_from`, C = `${l}_to`;
    m === "from" ? g ? (b[y] = g, b[C] || (b[C] = c())) : (delete b[y], b[C] === c() && delete b[C]) : g ? b[C] = g : (delete b[C], b[y] && (b[C] = c())), r(b, []);
  }, u = (l) => {
    const m = `${l.source}_from`, g = `${l.source}_to`;
    return t[m] !== void 0 || t[g] !== void 0;
  }, d = () => {
    r({}, []);
  }, p = (l) => {
    const m = new Set(n);
    m.has(l) ? m.delete(l) : m.add(l), s(m);
  }, h = (l) => l.dateInput ? u(l) : t[l.source] !== void 0;
  return V(() => {
    const l = { ...t };
    let m = !1;
    e.forEach((g) => {
      if (g.dateInput) {
        const b = `${g.source}_from`, y = `${g.source}_to`, C = t[b], R = t[y];
        C && !R && (l[y] = c(), m = !0);
      }
    }), m && r(l, []);
  }, [t, e, r]), /* @__PURE__ */ o(
    _,
    {
      sx: {
        order: -1,
        mr: 2,
        mt: 9,
        width: 200,
        minWidth: 200,
        flexShrink: 0,
        position: "sticky",
        top: 8,
        alignSelf: "flex-start",
        display: "block !important",
        visibility: "visible !important",
        // maxHeight: 'calc(100vh - 100px)',
        maxHeight: "65vh",
        overflowY: "auto",
        borderRadius: "8px",
        boxShadow: "0 2px 4px -1px rgba(0, 0, 0, 0.06), 0 1px 2px -1px rgba(0, 0, 0, 0.06)",
        backgroundColor: "#fafbfc",
        border: "1px solid #f1f5f9"
      },
      children: /* @__PURE__ */ f(j, { children: [
        /* @__PURE__ */ f(x, { sx: { display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }, children: [
          /* @__PURE__ */ o(ue, { title: "Filters", sx: { textDecoration: "underline", fontSize: "1.2rem", fontWeight: "bold", p: 0 } }),
          /* @__PURE__ */ o(be, { size: "small", onClick: d, sx: { fontSize: "0.75rem" }, children: "Clear" })
        ] }),
        /* @__PURE__ */ o(sr, {}),
        e.map((l) => /* @__PURE__ */ f(ir, { label: l.label, icon: l.icon, children: [
          l.dateInput && (() => {
            const m = `${l.source}_from`, g = `${l.source}_to`, b = t[m] || "", y = t[g] || "";
            return /* @__PURE__ */ f(x, { sx: { p: 1, display: "flex", flexDirection: "column", gap: 1.5 }, children: [
              /* @__PURE__ */ f(x, { children: [
                /* @__PURE__ */ o(Nt, { sx: { fontSize: "0.75rem", mb: 0.5, color: "text.secondary" }, children: "From Date" }),
                /* @__PURE__ */ o(Ge, { type: "date", size: "small", fullWidth: !0, value: b, onChange: (C) => i(l.source, "from", C.target.value), slotProps: { inputLabel: { shrink: !0 } }, sx: { "& .MuiInputBase-root": { fontSize: "0.875rem" } } })
              ] }),
              /* @__PURE__ */ f(x, { children: [
                /* @__PURE__ */ o(Nt, { sx: { fontSize: "0.75rem", mb: 0.5, color: "text.secondary" }, children: "To Date" }),
                /* @__PURE__ */ o(Ge, { type: "date", size: "small", fullWidth: !0, value: y, onChange: (C) => i(l.source, "to", C.target.value), slotProps: { inputLabel: { shrink: !0 } }, sx: { "& .MuiInputBase-root": { fontSize: "0.875rem" } } })
              ] })
            ] });
          })(),
          l.hasInput && !l.dateInput && /* @__PURE__ */ o(x, { sx: { p: 1 }, children: /* @__PURE__ */ o(Ge, { size: "small", fullWidth: !0, placeholder: l.placeholder, value: t[l.source] || "", onChange: (m) => a(l.source, m.target.value) }) }),
          l.options && l.options.length > 0 && /* @__PURE__ */ f(x, { sx: { ml: 1 }, children: [
            /* @__PURE__ */ f(
              x,
              {
                sx: {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  py: 0.5,
                  px: 1,
                  backgroundColor: h(l) ? "#e3f2fd" : "#f8fafc",
                  borderRadius: "4px",
                  border: h(l) ? "1px solid #bbdefb" : "1px solid #e2e8f0",
                  cursor: "pointer",
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    backgroundColor: h(l) ? "#e3f2fd" : "#e2e8f0"
                  }
                },
                children: [
                  /* @__PURE__ */ f(
                    x,
                    {
                      sx: {
                        fontSize: "0.75rem",
                        fontWeight: 500,
                        color: h(l) ? "#1976d2" : "#64748b"
                      },
                      children: [
                        "Options (",
                        l.options.length,
                        ")"
                      ]
                    }
                  ),
                  /* @__PURE__ */ o(
                    Ee,
                    {
                      size: "small",
                      onClick: () => p(l.source),
                      sx: {
                        p: 0.25,
                        transition: "transform 0.2s ease-in-out",
                        transform: n.has(l.source) || h(l) ? "rotate(0deg)" : "rotate(-90deg)"
                      },
                      children: /* @__PURE__ */ o(xo, { sx: { fontSize: 16 } })
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ o(fo, { in: n.has(l.source) || h(l), timeout: 200, children: /* @__PURE__ */ o(
              x,
              {
                sx: {
                  mt: 0.5,
                  pl: 2,
                  borderLeft: "2px solid #e2e8f0",
                  borderRadius: "0 4px 4px 0",
                  backgroundColor: "#f8fafc"
                },
                children: l.options.map((m) => /* @__PURE__ */ o(
                  ar,
                  {
                    label: m.label,
                    value: { [l.source]: m.value },
                    sx: {
                      py: 0.5,
                      px: 1,
                      borderRadius: "4px",
                      transition: "all 0.2s ease-in-out",
                      "&:hover": {
                        backgroundColor: "#e2e8f0",
                        transform: "translateX(2px)"
                      },
                      "& .MuiListItemText-root": {
                        margin: 0
                      },
                      "& .MuiTypography-root": {
                        fontSize: "0.875rem",
                        fontWeight: 500
                      }
                    }
                  },
                  m.value
                ))
              }
            ) })
          ] })
        ] }, l.source))
      ] })
    }
  );
}, Gs = {
  accepted: Ve.green[500],
  pending: Ve.orange[500],
  rejected: Ve.red[500]
}, Vs = (e, t) => {
  const r = [/* @__PURE__ */ o(lr, { source: "q", alwaysOn: !0, placeholder: t })];
  return r.push(
    /* @__PURE__ */ o(
      nt,
      {
        source: "status",
        emptyText: "None (Clear Selection)",
        choices: [
          { id: "accepted", name: "Accepted" },
          { id: "pending", name: "Pending" },
          { id: "rejected", name: "Rejected" }
        ],
        optionText: (n) => /* @__PURE__ */ f(X, { children: [
          /* @__PURE__ */ o(
            x,
            {
              component: "span",
              sx: {
                bgcolor: Gs[n.id],
                width: 8,
                height: 8,
                borderRadius: 4,
                mr: 1,
                display: "inline-block"
              }
            }
          ),
          n.name
        ] })
      }
    )
  ), r.push(
    /* @__PURE__ */ o(lo, { source: "clientUserId", reference: D.clientUsers, children: /* @__PURE__ */ o(
      uo,
      {
        optionText: (n) => n?.id ? `${n.firstName} ${n.lastName}` : "",
        sx: { minWidth: 200 }
      }
    ) })
  ), r;
}, Hs = 6, Ks = () => {
  const e = st(), { defaultTitle: t } = se();
  return /* @__PURE__ */ f(X, { children: [
    /* @__PURE__ */ o("title", { children: `${e} - ${t}` }),
    /* @__PURE__ */ o("span", { children: t })
  ] });
}, Js = () => /* @__PURE__ */ f(x, { sx: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: 400, gap: 2 }, children: [
  /* @__PURE__ */ o($e, { size: 40 }),
  /* @__PURE__ */ o(I, { variant: "body1", color: "text.secondary", children: "Loading data..." })
] }), Ys = () => /* @__PURE__ */ f(x, { sx: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: 320, gap: 1, textAlign: "center", color: "text.secondary" }, children: [
  /* @__PURE__ */ o(qr, { sx: { fontSize: 44, opacity: 0.45 } }),
  /* @__PURE__ */ o(I, { variant: "subtitle1", sx: { fontWeight: 600, color: "text.primary" }, children: "No records found" }),
  /* @__PURE__ */ o(I, { variant: "body2", children: "Try adjusting your filters or search to see results." })
] }), qs = ({ isXSmall: e, fields: t, rowActions: r, expandListComponent: n, disableBulkActions: s }) => {
  const { isLoading: a, isFetching: c, total: i } = se();
  return a || c ? /* @__PURE__ */ o(Js, {}) : i === 0 ? /* @__PURE__ */ o(Ys, {}) : e ? /* @__PURE__ */ o(Us, { fields: t }) : /* @__PURE__ */ o(js, { fields: t, rowActions: r, expandListComponent: n, disableBulkActions: s });
}, Ui = ({
  perPage: e = 25,
  sort: t = { field: "_id", order: "DESC" },
  fields: r,
  filterColumns: n,
  title: s,
  titleSubtitle: a,
  rowActions: c,
  expandListComponent: i,
  qSearchplaceholder: u = "Search...",
  DefaultListPageActions: d,
  disableBulkActions: p = !1,
  filters: h,
  filterDefaultValues: l,
  titleAction: m,
  ...g
}) => {
  const b = Dr(), y = Lr(b.breakpoints.down("sm")), [, C] = cr(), R = r.length + (c ? 1 : 0);
  V(() => {
    y || R >= Hs && C(!1);
  }, [R, y, C]);
  const P = h ?? Vs({}, u);
  return /* @__PURE__ */ f(
    x,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        maxWidth: "100%",
        pt: 1,
        overflow: "visible",
        boxSizing: "border-box"
      },
      children: [
        /* @__PURE__ */ f(
          x,
          {
            sx: {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              p: 0
            },
            children: [
              /* @__PURE__ */ f(x, { children: [
                /* @__PURE__ */ o(
                  I,
                  {
                    variant: "h6",
                    component: "h1",
                    sx: {
                      mb: a ? 0.5 : 2,
                      fontSize: "1.125rem",
                      fontWeight: 600,
                      color: "text.primary",
                      letterSpacing: "-0.01em"
                    },
                    children: s
                  }
                ),
                a ? /* @__PURE__ */ o(I, { variant: "body2", color: "text.secondary", sx: { mb: 2 }, children: a }) : null
              ] }),
              m
            ]
          }
        ),
        /* @__PURE__ */ o(
          dr,
          {
            ...g,
            storeKey: !1,
            sx: {
              flex: 1,
              display: "flex",
              flexDirection: "column",
              minWidth: 0,
              maxWidth: "100%",
              overflow: "visible",
              "& .RaList-main": {
                flex: 1,
                minWidth: 0,
                overflow: "visible"
              },
              // Pagination reads as part of the same surface: a little breathing room + muted controls
              "& .MuiTablePagination-root": {
                mt: 1,
                color: "text.secondary"
              },
              "& .MuiTablePagination-toolbar": {
                minHeight: 52
              }
            },
            aside: n ? /* @__PURE__ */ o(Bs, { filterColumns: n }) : void 0,
            filters: P,
            filterDefaultValues: l,
            perPage: e,
            sort: t,
            actions: d,
            title: /* @__PURE__ */ o(Ks, {}),
            exporter: Qs,
            children: /* @__PURE__ */ o(qs, { isXSmall: y, fields: r, rowActions: c, expandListComponent: i, disableBulkActions: p })
          }
        )
      ]
    }
  );
}, Qs = async (e) => Qr(e, {}, (t, r) => {
  ur(r, "records");
}), Wi = ({ fields: e, actions: t, layout: r = hr, pageHeader: n, title: s }) => {
  te();
  const { permissions: a, isPending: c } = mr(), { name: i } = pr();
  return /* @__PURE__ */ o(gr, { actions: t, title: s || i, children: /* @__PURE__ */ o(r, { children: /* @__PURE__ */ f(x, { sx: { maxWidth: "1200px", py: 4, px: 3, ml: "auto" }, children: [
    n && /* @__PURE__ */ o(
      I,
      {
        variant: "h4",
        component: "h2",
        sx: {
          mb: 4,
          fontWeight: 600,
          color: "text.primary",
          letterSpacing: "-0.01em",
          fontSize: "1.5rem"
        },
        children: n
      }
    ),
    /* @__PURE__ */ o(
      x,
      {
        sx: {
          backgroundColor: "background.paper",
          borderRadius: 2,
          p: 4,
          boxShadow: 2,
          border: "1px solid",
          borderColor: "divider"
        },
        children: /* @__PURE__ */ o(
          x,
          {
            sx: {
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "repeat(2, 1fr)"
              },
              columnGap: 8,
              rowGap: 4,
              "& .RaLabeled-label": {
                fontWeight: 600,
                fontSize: "0.75rem",
                color: "text.secondary",
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                mb: 1.5
              },
              "& .RaLabeled-value": {
                fontSize: "1rem",
                color: "text.primary",
                lineHeight: 1.6,
                fontWeight: 400
              }
            },
            children: e?.map(({ componentName: d, label: p, ...h }, l) => {
              const m = pt(d, { ...h, label: p }, !0);
              return /* @__PURE__ */ o(
                x,
                {
                  sx: {
                    pb: 3.5,
                    borderBottom: "1px solid",
                    borderColor: "divider",
                    "&:nth-of-type(2n-1):nth-last-of-type(-n+2), &:nth-of-type(2n):nth-last-of-type(-n+2)": {
                      borderBottom: "none",
                      pb: 0
                    },
                    "@media (max-width: 900px)": {
                      "&:last-of-type": {
                        borderBottom: "none",
                        pb: 0
                      }
                    }
                  },
                  children: m
                },
                l
              );
            })
          }
        )
      }
    )
  ] }) }) });
};
export {
  en as AcceptButton,
  Ti as AssignRolesModal,
  $o as AvatarField,
  on as BulkAcceptButton,
  nn as BulkRejectButton,
  wi as ClientUserItem,
  xs as CompanyLobSelector,
  Ci as CustomerDetailsCard,
  xi as CustomerLinkField,
  $i as DefaultCreatePage,
  Mi as DefaultEditPage,
  Ts as DefaultItem,
  Ui as DefaultListPage,
  Wi as DefaultShowPage,
  ys as DependentReferenceArrayInput,
  Ii as EntitySummaryCard,
  yi as ExpandListPayments,
  pt as FieldSelector,
  as as FullNameField,
  ki as InfoCard,
  Si as InfoField,
  Mo as InputSelector,
  bs as PermissionSelector,
  sn as RejectButton,
  Ri as RelatedDatagrid,
  ye as RichText,
  Zn as TestButton,
  vi as ThumbnailField,
  Ai as TroubleshootingGuidelines,
  Ei as authFeathersProvider,
  es as canAccessService,
  bi as constants,
  zi as dataFeathersProvider,
  fi as formatValue,
  D as resources,
  ts as resourcesForRoles,
  os as serviceDisplayNames,
  Pi as useUserCompanyChoices,
  Ni as useUserLobChoices,
  Fi as useUserRoles,
  Li as useUserSourceSystems,
  Di as useUserTerritoryChoices
};
